import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { useNavigate, useParams } from "react-router-dom";
import DocModal from "../../RFPDashboard/RecceApproval/docModal.js";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { Menu, ListItemIcon, ListItemText } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import {
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  CircularProgress,
  Pagination,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  Stack,
  TextField,
  DialogContent,
  Chip,
  Tooltip,
  Modal,
  Box,
  IconButton,
  Typography,
  Checkbox,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import styles from "../../RFPDashboard/RecceApproval/rfp.module.css";
import Swal from "sweetalert2";
import RecceReport from "../../RFPDashboard/RecceApproval/RecceReport.js";
import axios from "axios";
import GlobalSnackbar from "../../../shared/utils/GlobalSnackbar.jsx";
import Styles from "../../../styles/adminPortal.module.css";
import {
  BorderLeft,
  EditOutlined,
  ImageOutlined,
  UploadFileOutlined,
  VisibilityOutlined,
} from "@mui/icons-material";
import RecceRejectedModal from "./RecceRejectedModal.js";
import ApprovalModal from "./ApprovalModal.js";
import PolygonDown from "../../../shared/assets/icons/PolygonDown.jsx";
import socket from "../../../shared/utils/Socket.js";
import TemplateModal from "../../LandingPages/TemplateModal.js";
import Back from "../../../shared/assets/icons/Back.jsx";
import GlobalDropdownField from "../../../shared/utils/GlobalDropdownField.jsx";
import MinMaxFileUploader from "../../../shared/utils/minmaxFileUploader.js";
import CapitalizeFirstLetter from "../../../shared/utils/CapitalizeFirstLetter.jsx";
import DragDropUpload from "../DragDropUpload.jsx";
import RecceApprovalTable from "../../RFPDashboard/RecceApproval/RecceApprovalTable.js";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import AddOutlined from "@mui/icons-material/AddOutlined";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import RemarkModal from "../RecceApproval/RemarkModal.jsx";
import ReportIcon from "../../../shared/assets/icons/ReportIcon.jsx";
import GlobalButton from "../../../shared/utils/GlobalButton.jsx";
import sortRowsAlphabetically from "../../../shared/utils/sortRowsAlphabetically.js";

const AdminApprovalTable = () => {
  const { id } = useParams();
  const [finalSpaces, setFinalSpaces] = useState([]);
  const [pageSize, setPageSize] = useState(20);
  const pageSizeOptions = [1, 5, 10, 20, 50, 100, 200, 500];
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [campaignListLoading, setCampaignListLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [open, setOpen] = useState(false);
  const [jobApprovals, setJobApprovals] = React.useState([]);
  const [clientCreativeStatus, setClientCreativeStatus] = useState({});
  const [filterJobApprovals, setFilterJobApprovals] = React.useState([]);
  const [currentApproval, setCurrentApproval] = useState();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [approvalDialogOpen, setApprovalDialogOpen] = useState(false);
  const [isBulkApproval, setIsBulkApproval] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const [selectedRow, setSelectedRow] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedApprovals, setSelectedApprovals] = useState([]);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [selectedStore, setSelectedStore] = useState([]);
  const [selectedZone, setSelectedZone] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState([]);
  const [selectedAdminStatus, setSelectedAdminStatus] = useState([]);
  const [selectedCreativeStatus, setSelectedCreativeStatus] = useState([]);
  const [selectedClientStatus, setSelectedClientStatus] = useState([]);
  const [storeOptions, setStoreOptions] = useState([]);
  const [zoneOptions, setZoneOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [rotate, setRotate] = useState(false);
  const [cityOptions, setCityOptions] = useState([]);
  const [allCitiesByState, setAllCitiesByState] = useState({});
  const [allProductTypeOptions, setAllProductTypeOptions] = useState([]);
  const [productTypesByStateCityMap, setProductTypesByStateCityMap] = useState(
    {},
  );
  const [productTypesByState, setProductTypesByState] = useState({});
  const [productTypesByCity, setProductTypesByCity] = useState({});
  const [approvedCount, setApprovedCount] = useState("");
  const [rejectedCount, setRejectedCount] = useState("");
  const [holdOnCount, setHoldOnCount] = useState("");
  const [pendingCount, setPendingCount] = useState("");
  const [totalCount, setTotalCount] = useState("");
  const [isPreviewCompletionReport, setPreviewCompletionReport] =
    useState(false);
  const [openCreative, setOpenCreative] = useState(false);
  const [creativeTitle, setCreativeTitle] = useState("");
  const [uploadLoading, setUploadLoading] = useState(false);
  const [creativeFile, setCreativeFile] = useState("");
  const [selectedApproval, setSelectedApproval] = useState(null);
  const [docModalOpen, setDocModalOpen] = useState(false);
  const [clientApprovalOpen, setClientApprovalOpen] = useState(false);
  const [storeSortOrder, setStoreSortOrder] = useState(null);
  const [zoneSortOrder, setZoneSortOrder] = useState(null);
  const [allApprovals, setAllApprovals] = React.useState([]);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const [hoveredImage, setHoveredImage] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [hoveredImageAdmin, setHoveredImageAdmin] = useState(null);
  const [anchorElAdmin, setAnchorElAdmin] = useState(null);
  const isFirstCallRef = useRef(true);
  const navigate = useNavigate();
  const selectedCityRef = useRef(selectedCity);
  const selectedStateRef = useRef(selectedState);
  const selectedProductTypeRef = useRef(selectedProductType);
  const selectedStoreRef = useRef(selectedStore);
  const selectedZoneRef = useRef(selectedZone);
  const selectedAdminStatusRef = useRef(selectedAdminStatus);
  const selectedClientStatusRef = useRef(selectedClientStatus);
  const selectedCreativeStatusRef = useRef(selectedCreativeStatus);
  const [productList, setProductList] = useState([]);
  const [isUserAction, setIsUserAction] = useState(false);
  const isUserActionRef = useRef(false);

  // Remark of product during recce

  const [openRemarkModal, setOpenRemarkModal] = useState(false);

  const [openReferenceImageModal, setOpenReferenceImageModal] = useState(false);
  const [referenceImage, setReferenceImage] = useState(null);
  const [refreshCreative, setRefreshCreative] = useState(false);

  const [remarkText, setRemarkText] = useState("");
  const [isEditingRemark, setIsEditingRemark] = useState(false);

  const [searchInputs, setSearchInputs] = useState({
    city: "",
    state: "",
    productType: "",
    adminStatus: "",
    clientStatus: "",
    store: [],
    zone: [],
  });

  const [anchorE2, setAnchorE2] = useState(null);

  // HELPER FUNCTIONS FOR UPDATING COUNTS
  const updateCountsAfterApproval = (count) => {
    setApprovedCount((prev) => (prev || 0) + count);
    setPendingCount((prev) => Math.max(0, (prev || 0) - count));
  };

  const updateCountsAfterRejection = (count) => {
    setRejectedCount((prev) => (prev || 0) + count);
    setPendingCount((prev) => Math.max(0, (prev || 0) - count));
  };

  // ADD THIS HELPER FUNCTION
  const updateUserAction = (value) => {
    setIsUserAction(value);
    isUserActionRef.current = value;
  };

  useEffect(() => {
    selectedCityRef.current = selectedCity;
    selectedStateRef.current = selectedState;
    selectedProductTypeRef.current = selectedProductType;
    selectedStoreRef.current = selectedStore;
    selectedZoneRef.current = selectedZone;
    selectedAdminStatusRef.current = selectedAdminStatus;
    selectedClientStatusRef.current = selectedClientStatus;
    selectedCreativeStatusRef.current = selectedCreativeStatus;
  }, [
    selectedCity,
    selectedState,
    selectedProductType,
    selectedStore,
    selectedZone,
    selectedAdminStatus,
    selectedClientStatus,
    selectedCreativeStatus,
  ]);

  const sortByStoreName = () => {
    const nextSortOrder = storeSortOrder === "asc" ? "desc" : "asc";
    setJobApprovals(
      sortRowsAlphabetically(
        jobApprovals,
        (approval) => approval?.job?.storeName,
        nextSortOrder,
      ),
    );
    // setFilterJobApprovals(sorted.filter((f) => f.clientStatus !== -1));
    setStoreSortOrder(nextSortOrder);
  };

  const sortByZone = () => {
    const nextSortOrder = zoneSortOrder === "asc" ? "desc" : "asc";
    setJobApprovals(
      sortRowsAlphabetically(
        jobApprovals,
        (approval) => approval?.job?.zone,
        nextSortOrder,
      ),
    );
    setZoneSortOrder(nextSortOrder);
  };

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const serverURL = process.env.REACT_APP_URL;
  const token = localStorage.getItem("token");

  // Function to get comment based on status
  const getCommentForStatus = React.useCallback((approval) => {
    if (approval.adminStatus === 1) {
      return approval.approvalReason || "No reason provided";
    } else if (approval.adminStatus === -1) {
      return approval.rejectionReason || "No reason provided";
    }

    if (approval.clientStatus === 1) {
      return approval.clientApprovalReason || "No reason provided";
    } else if (approval.clientStatus === -1) {
      return approval.clientrejectionReason || "No reason provided";
    } else if (approval.clientStatus === 2) {
      return approval.clientHoldOnReason || "No reason provided";
    }
    return "";
  }, []);

  const latestRequestRef = React.useRef(0);
  const getApprovalList = useCallback(
    async (
      cityName,
      stateName,
      productType,
      storeName,
      adminStatus,
      clientStatus,
      creativeStatus,
      debouncedSearch,
      zoneName = [],
    ) => {
      if (isUserActionRef.current) {
        return;
      }

      const requestId = ++latestRequestRef.current;
      setCampaignListLoading(true);
      try {
        const response = await axios.get(
          `${serverURL}/installationPartnerJobApproval/viewAllJobApprovals?page=${page}&limit=${pageSize}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
            },
            params: {
              campaignId: id,
              city: cityName?.includes("ALL") ? [] : cityName,
              state: stateName?.includes("ALL") ? [] : stateName,
              store: storeName?.includes("ALL") ? [] : storeName,
              zone: zoneName?.includes("ALL") ? [] : zoneName,
              productType: productType?.includes("ALL") ? [] : productType,
              adminStatus: adminStatus?.includes("ALL") ? [] : adminStatus,
              clientStatus: clientStatus?.includes("ALL") ? [] : clientStatus,
              clientCreativeStatus: creativeStatus?.includes("All")
                ? []
                : creativeStatus,
              search: debouncedSearch || "",
            },
          },
        );
        if (requestId != latestRequestRef.current) return;
        if (response?.data?.success) {
          const approvals = response?.data?.data || [];
          setJobApprovals(approvals);
          setAllApprovals(approvals);
          let creativeStatus = response?.data?.data.reduce(
            (acc, curr) => {
              acc.pending += curr?.job?.clientCreativeStatus === 0 ? 1 : 0;
              acc.rejected += curr?.job?.clientCreativeStatus === -1 ? 1 : 0;
              acc.approved += curr?.job?.clientCreativeStatus === 1 ? 1 : 0;

              return acc;
            },
            {
              pending: 0,
              rejected: 0,
              approved: 0,
            },
          );
          setClientCreativeStatus(creativeStatus);
          // remove comment for pagination
          setTotalPages(response?.data?.totalCountResult);
          // end remove comment for pagination

          setPreviewCompletionReport(response?.data?.isAllJobsDone);
          setSelectedApprovals([]);
          setIsSelectAll(false);

          // Format options
          const formattedCityOptions = (response?.data?.cityOptions || [])
            .filter((city) => {
              const label = typeof city === "string" ? city : city?.label;
              return label && label !== "All";
            })
            .map((city) =>
              typeof city === "string" ? { label: city, value: city } : city,
            );

          const formattedStateOptions = (response?.data?.stateOptions || [])
            .filter((state) => {
              const label = typeof state === "string" ? state : state?.label;
              return label && label !== "Select State" && label !== "All";
            })
            .map((state) =>
              typeof state === "string"
                ? { label: state, value: state }
                : state,
            );

          const formattedStoreOptions = (response?.data?.storeOptions || [])
            .filter((store) => {
              const label = typeof store === "string" ? store : store?.label;
              return label && label !== "Select Store" && label !== "All";
            })
            .map((store) =>
              typeof store === "string"
                ? { label: store, value: store }
                : store,
            );
          const formattedZoneOptions = (response?.data?.zoneOptions || [])
            .filter((zone) => {
              const label = typeof zone === "string" ? zone : zone?.label;
              return label && label !== "All";
            })
            .map((zone) =>
              typeof zone === "string" ? { label: zone, value: zone } : zone,
            );
          // Build city-state mapping from current response data
          // const citiesStateMapping = {};
          // if (response?.data?.data && Array.isArray(response?.data?.data)) {
          //   response?.data?.data.forEach((approval) => {
          //     // Get state and city from the job object
          //     const state = approval?.job?.state;
          //     const city = approval?.job?.city;
          //     if (state && city) {
          //       if (!citiesStateMapping[state]) {
          //         citiesStateMapping[state] = [];
          //       }
          //       if (!citiesStateMapping[state].includes(city)) {
          //         citiesStateMapping[state].push(city);
          //       }
          //     }
          //   });
          // }

          // Only do this on initial load (when no filters are applied)

          // if (isFirstCallRef.current) {
          // setAllCitiesByState(citiesStateMapping);
          setAllCitiesByState(response?.data?.citiesStateMapping);
          // isFirstCallRef.current = false;
          // }
          // Use ALL product types from backend (unfiltered)
          const allProductTypes = (
            response?.data?.allProductTypeOptions ||
            response?.data?.productTypeOptions ||
            []
          ).filter((type) => {
            const label = typeof type === "string" ? type : type?.label;
            return label && label !== "All";
          });

          const formattedAllProductTypes = allProductTypes.map((type) =>
            typeof type === "string" ? { label: type, value: type } : type,
          );

          // Store all product types (unfiltered)
          setAllProductTypeOptions(formattedAllProductTypes);

          // Store all city options
          setCityOptions((prev) => {
            const existing = new Set(prev.map((c) => c.value));

            const merged = [
              ...prev,
              ...formattedCityOptions.filter((c) => !existing.has(c.value)),
            ];

            return merged;
          });
          setStateOptions(formattedStateOptions);
          setStoreOptions(formattedStoreOptions);
          setZoneOptions((prev) => {
            const existing = new Set(prev.map((zone) => zone.value));
            return [
              ...prev,
              ...formattedZoneOptions.filter(
                (zone) => !existing.has(zone.value),
              ),
            ];
          });
          // Sync searchInputs with current filter selections
          setSearchInputs({
            city: cityName === "All" || cityName == null ? "" : cityName,
            state: stateName === "All" || stateName == null ? "" : stateName,
            store: storeName === "All" || storeName == null ? "" : storeName,
            zone: zoneName === "All" || zoneName == null ? [] : zoneName,
            productType:
              productType === "All" || productType == null ? "" : productType,

            adminStatus:
              adminStatus === "All" || adminStatus == null ? "" : adminStatus,

            clientStatus:
              clientStatus === "All" || clientStatus == null
                ? ""
                : clientStatus,
          });

          setApprovedCount(response?.data?.adminApprovedCount);
          setRejectedCount(response?.data?.rejectedCount);
          setHoldOnCount(response?.data?.holdOnCount);
          setPendingCount(response?.data?.adminPendingCount);
          setTotalCount(response?.data?.count);
        }
      } catch (error) {
        console.error("Error fetching campaign:", error);
      } finally {
        if (requestId === latestRequestRef.current) {
          setCampaignListLoading(false);
        }
      }
    },
    [serverURL, token, id, page, pageSize],
  );

  // Handle individual selection
  const handleSelectApproval = React.useCallback((approvalId) => {
    setSelectedApprovals((prev) => {
      if (prev.includes(approvalId)) {
        return prev.filter((id) => id !== approvalId);
      } else {
        return [...prev, approvalId];
      }
    });
  }, []);

  // Handle select all on current page
  const handleSelectAll = useCallback(() => {
    if (isSelectAll) {
      setSelectedApprovals([]);
    } else {
      const allIds = jobApprovals
        .filter((approval) => approval.adminStatus === 0)
        .map((approval) => approval._id);
      setSelectedApprovals(allIds);
    }
    setIsSelectAll(!isSelectAll);
  }, [isSelectAll, jobApprovals]);

  // Check if approval can be selected
  const canSelectApproval = React.useCallback((approval) => {
    return approval.adminStatus === 0;
  }, []);

  // Bulk approval function
  const handleBulkApprove = useCallback(async () => {
    if (selectedApprovals.length === 0) {
      setSnackbar({
        open: true,
        message: "Please select at least one job to approve",
        severity: "warning",
      });
      return;
    }

    // Open approval modal for bulk approval
    setIsBulkApproval(true);
    setApprovalDialogOpen(true);
  }, [selectedApprovals]);

  // Bulk rejection function
  const handleBulkReject = useCallback(async () => {
    if (selectedApprovals.length === 0) {
      setSnackbar({
        open: true,
        message: "Please select at least one job to reject",
        severity: "warning",
      });
      return;
    }
    setDialogOpen(true);
  }, [selectedApprovals]);

  const resetFilters = useCallback(() => {
    setSelectedCity([]);
    setSelectedState([]);
    setSelectedStore([]);
    setSelectedZone([]);
    setSelectedProductType([]);
    setSelectedAdminStatus([]);
    setSelectedClientStatus([]);
    setSelectedCreativeStatus([]);
    setSearchInputs({
      city: "",
      state: "",
      productType: "",
      adminStatus: "",
      clientStatus: "",
      storeName: "",
      zone: [],
    });
    getApprovalList("", "All", "All", "", "", "", "", debouncedSearch, []);
    setRotate(true);
    setTimeout(() => setRotate(false), 500);
  }, [debouncedSearch]);

  const handleMultiSelectAll = (value, prev, options) => {
    const added = value.find((v) => !prev.includes(v));
    const removed = prev.find((v) => !value.includes(v));

    const allValues = options.map((opt) => opt.value);

    // 👉 ALL selected
    if (added === "ALL") {
      return ["ALL", ...allValues];
    }

    // 👉 ALL removed
    if (removed === "ALL") {
      return [];
    }

    // 👉 Remove one when ALL was selected
    if (prev.includes("ALL") && removed) {
      return allValues.filter((v) => v !== removed);
    }

    // 👉 Normal selection
    if (value.length === allValues.length) {
      return ["ALL", ...value];
    }

    return value.filter((v) => v !== "ALL");
  };
  const getFilteredCities = useCallback(() => {
    const cleanStates = selectedState.includes("ALL")
      ? Object.keys(allCitiesByState)
      : selectedState.length === 0
        ? Object.keys(allCitiesByState)
        : selectedState;

    const citiesForStates = cleanStates.flatMap(
      (st) => allCitiesByState[st] || [],
    );

    return cityOptions.filter((city) => citiesForStates.includes(city.value));
  }, [selectedState, allCitiesByState, cityOptions]);
  const handleSearchChangeHead = useCallback(
    (e, key) => {
      const value = e.target.value;
      let newStore = selectedStore;
      let newZone = selectedZone;
      let newProductType = selectedProductType;
      let newState = selectedState;
      let newCity = selectedCity;
      setPage(1);

      setSearchInputs((prevState) => {
        const updatedInputs = { ...prevState, [key]: value };

        // Determine the new state values
        let newAdminStatus = selectedAdminStatus;
        let newClientStatus = selectedClientStatus;
        let newCreativeStatus = selectedCreativeStatus;

        // Update filter selections based on which filter is changing
        if (key === "city") {
          newStore = [];
          const filteredCities = getFilteredCities();
          const allValues = filteredCities.map((c) => c.value);

          let incoming = Array.isArray(value) ? value : [value];
          const prev = selectedCity || [];

          // 👉 Detect what changed
          const added = incoming.find((v) => !prev.includes(v));
          const removed = prev.find((v) => !incoming.includes(v));

          // 👉 CASE 1: ALL clicked
          if (added === "ALL") {
            newCity = ["ALL", ...allValues];
          }

          // 👉 CASE 2: ALL unchecked
          else if (removed === "ALL") {
            newCity = [];
          }

          // 👉 CASE 3: Removing one item when ALL is selected
          else if (prev.includes("ALL") && removed) {
            newCity = allValues.filter((v) => v !== removed); // remove only that one
          }

          // 👉 CASE 4: Normal selection
          else {
            newCity = incoming.filter((v) => v !== "ALL");

            // 👉 If all manually selected → add ALL
            const isAllSelected =
              allValues.length > 0 &&
              allValues.every((val) => newCity.includes(val));

            if (isAllSelected) {
              newCity = ["ALL", ...allValues];
            }
          }
        } else if (key === "state") {
          const prevState = selectedState || [];
          newCity = [];
          newStore = [];

          newState = handleMultiSelectAll(value, prevState, stateOptions);

          // 🔥 Remove ALL before using in logic
          const cleanStates = newState.includes("ALL")
            ? stateOptions.map((s) => s.value)
            : newState;

          // 👉 Reset city if invalid
          if (selectedCity?.length > 0) {
            const validCities = cleanStates.flatMap(
              (st) => allCitiesByState[st] || [],
            );

            const filteredCities = selectedCity.filter((city) =>
              validCities.includes(city),
            );
          }

          // 👉 ProductType validation
          if (newProductType?.length) {
            const isValid = isProductTypeValidForFilters(
              newProductType,
              cleanStates,
              newCity,
            );
            if (!isValid) {
              newProductType = [];
            }
          }
        } else if (key === "productType") {
          const prev = selectedProductType || [];

          if (Array.isArray(value)) {
            const added = value.find((v) => !prev.includes(v));
            const removed = prev.find((v) => !value.includes(v));

            const allValues = allProductTypeOptions.map((p) => p.value);

            // 👉 ALL selected
            if (added === "ALL") {
              newProductType = ["ALL", ...allValues];
            }
            // 👉 ALL removed
            else if (removed === "ALL") {
              newProductType = [];
            }
            // 👉 Remove one when ALL was selected
            else if (prev.includes("ALL") && removed) {
              newProductType = allValues.filter((v) => v !== removed);
            }
            // 👉 Normal selection
            else {
              if (value.length === allValues.length) {
                newProductType = ["ALL", ...value];
              } else {
                newProductType = value.filter((v) => v !== "ALL");
              }
            }
          } else {
            newProductType = [];
          }
        } else if (key === "store") {
          if (Array.isArray(value)) {
            const prev = selectedStore || [];

            // 👉 Find what changed
            const added = value.find((v) => !prev.includes(v));
            const removed = prev.find((v) => !value.includes(v));

            // 👉 CASE 1: ALL clicked
            if (added === "ALL") {
              newStore = ["ALL", ...storeOptions.map((s) => s.value)];
            }
            // 👉 CASE 2: ALL unchecked
            else if (removed === "ALL") {
              newStore = [];
            }
            // 👉 CASE 3: Normal item removed while ALL was selected
            else if (prev.includes("ALL") && removed) {
              newStore = storeOptions
                .map((s) => s.value)
                .filter((v) => v !== removed); // remove only that item
            }
            // 👉 CASE 4: Normal selection
            else {
              if (value.length === storeOptions.length) {
                newStore = ["ALL", ...value];
              } else {
                newStore = value.filter((v) => v !== "ALL");
              }
            }
          } else {
            newStore = [];
          }
        } else if (key === "zone") {
          newZone = handleMultiSelectAll(
            value,
            selectedZone || [],
            zoneOptions,
          );
        } else if (key === "adminStatus") {
          const prev = selectedAdminStatus || [];

          if (Array.isArray(value)) {
            const added = value.find((v) => !prev.includes(v));
            const removed = prev.find((v) => !value.includes(v));
            const allValues = [1, -1, 0];

            if (added === "ALL") {
              newAdminStatus = ["ALL", ...allValues];
            }
            // 👉 ALL removed
            else if (removed === "ALL") {
              newAdminStatus = [];
            }
            // 👉 Remove one when ALL was selected
            else if (prev.includes("ALL") && removed) {
              newAdminStatus = allValues.filter((v) => v !== removed);
            }
            // 👉 Normal selection
            else {
              if (value.length === allValues.length) {
                newAdminStatus = ["ALL", ...value];
              } else {
                newAdminStatus = value.filter((v) => v !== "ALL");
              }
            }
          } else {
            newAdminStatus = [];
          }
        } else if (key === "clientStatus") {
          const prev = selectedClientStatus || [];

          if (Array.isArray(value)) {
            const added = value.find((v) => !prev.includes(v));
            const removed = prev.find((v) => !value.includes(v));

            const allValues = [1, -1, 2, 0];

            // 👉 ALL selected
            if (added === "ALL") {
              newClientStatus = ["ALL", ...allValues];
            }
            // 👉 ALL removed
            else if (removed === "ALL") {
              newClientStatus = [];
            }
            // 👉 Remove one when ALL was selected
            else if (prev.includes("ALL") && removed) {
              newClientStatus = allValues.filter((v) => v !== removed);
            }
            // 👉 Normal selection
            else {
              if (value.length === allValues.length) {
                newClientStatus = ["ALL", ...value];
              } else {
                newClientStatus = value.filter((v) => v !== "ALL");
              }
            }
          } else {
            newClientStatus = [];
          }
        } else if (key === "creativeStatus") {
          const prev = selectedCreativeStatus || [];

          if (Array.isArray(value)) {
            const added = value.find((v) => !prev.includes(v));
            const removed = prev.find((v) => !value.includes(v));
            const allValues = [1, -1, 0];

            if (added === "ALL") {
              newCreativeStatus = ["ALL", ...allValues];
            }
            // 👉 ALL removed
            else if (removed === "ALL") {
              newCreativeStatus = [];
            }
            // 👉 Remove one when ALL was selected
            else if (prev.includes("ALL") && removed) {
              newCreativeStatus = allValues.filter((v) => v !== removed);
            }
            // 👉 Normal selection
            else {
              if (value.length === allValues.length) {
                newCreativeStatus = ["ALL", ...value];
              } else {
                newCreativeStatus = value.filter((v) => v !== "ALL");
              }
            }
          } else {
            newCreativeStatus = [];
          }
        }

        // Update the main filter states
        setSelectedCity(newCity);
        setSelectedState(newState);
        setSelectedStore(newStore);
        setSelectedZone(newZone);
        setSelectedProductType(newProductType);
        setSelectedAdminStatus(newAdminStatus);
        setSelectedClientStatus(newClientStatus);
        setSelectedCreativeStatus(newCreativeStatus);

        // Fetch updated data with the new filter values
        getApprovalList(
          newCity,
          newState,
          newProductType,
          newStore,
          newAdminStatus,
          newClientStatus,
          newCreativeStatus,
          debouncedSearch,
          newZone,
        );

        return updatedInputs;
      });
    },
    [
      selectedState,
      selectedCity,
      selectedStore,
      selectedZone,
      selectedProductType,
      selectedAdminStatus,
      selectedClientStatus,
      selectedCreativeStatus,
      getFilteredCities,
      stateOptions,
      storeOptions,
      zoneOptions,
      allProductTypeOptions,
      allCitiesByState,
      getApprovalList,
      debouncedSearch,
    ],
  );

  // Helper function to check if product type is valid for current filters
  const isProductTypeValidForFilters = useCallback(
    (productType, state, city) => {
      if (!productType || productType === "") return false;

      if (state && state !== "" && city && city !== "") {
        // Check state-city combination
        const key = `${state}||${city}`;
        const availableProducts = productTypesByStateCityMap[key] || [];
        return availableProducts.includes(productType);
      } else if (state && state !== "" && (!city || city === "")) {
        // Check state only
        const availableProducts = productTypesByState[state] || [];
        return availableProducts.includes(productType);
      } else if (city && city !== "" && (!state || state === "")) {
        // Check city only
        const availableProducts = productTypesByCity[city] || [];
        return availableProducts.includes(productType);
      } else if ((!state || state === "") && (!city || city === "")) {
        // No filters, product type is valid (it's in all products)
        return allProductTypeOptions.some((pt) => pt.value === productType);
      }

      return false;
    },
    [
      productTypesByStateCityMap,
      productTypesByState,
      productTypesByCity,
      allProductTypeOptions,
    ],
  );

  const handleSnackbarClose = useCallback(() => {
    setSnackbar({ ...snackbar, open: false });
  }, [snackbar]);

  const handleAdminApproved = useCallback(async () => {
    if (isUserActionRef.current) {
      return;
    }
    await getApprovalList(
      selectedCityRef.current,
      selectedStateRef.current,
      selectedProductTypeRef.current,
      selectedStoreRef.current,
      selectedAdminStatusRef.current,
      selectedClientStatusRef.current,
      selectedCreativeStatusRef.current,
      debouncedSearch,
      selectedZoneRef.current,
    );
  }, [debouncedSearch]);

  useEffect(() => {
    socket.on("client-RecceStatus", handleAdminApproved);

    return () => {
      socket.off("client-RecceStatus", handleAdminApproved);
    };
  }, [handleAdminApproved]);

  // make city-state mapping and product-type mapping

  useEffect(() => {
    if (jobApprovals.length > 0) {
      const citiesStateMapping = {};
      const productTypeMapping = {};
      const productTypeByStateMapping = {};
      const productTypeByCityMapping = {};

      jobApprovals.forEach((approval) => {
        const state = approval?.job?.state;
        const city = approval?.job?.city;
        const productType = approval?.product?.productType;

        // Build city-state mapping
        if (state && city) {
          if (!citiesStateMapping[state]) {
            citiesStateMapping[state] = [];
          }
          if (!citiesStateMapping[state].includes(city)) {
            citiesStateMapping[state].push(city);
          }
        }

        // make product type mapping for state-city combination
        if (state && city && productType) {
          const key = `${state}||${city}`;
          if (!productTypeMapping[key]) {
            productTypeMapping[key] = [];
          }
          if (!productTypeMapping[key].includes(productType)) {
            productTypeMapping[key].push(productType);
          }
        }

        // Build product type mapping for state only
        if (state && productType) {
          if (!productTypeByStateMapping[state]) {
            productTypeByStateMapping[state] = [];
          }
          if (!productTypeByStateMapping[state].includes(productType)) {
            productTypeByStateMapping[state].push(productType);
          }
        }

        // Build product type mapping for city only
        if (city && productType) {
          if (!productTypeByCityMapping[city]) {
            productTypeByCityMapping[city] = [];
          }
          if (!productTypeByCityMapping[city].includes(productType)) {
            productTypeByCityMapping[city].push(productType);
          }
        }
      });

      if (Object.keys(productTypeMapping).length > 0) {
        setProductTypesByStateCityMap(productTypeMapping);
      }

      if (Object.keys(productTypeByStateMapping).length > 0) {
        setProductTypesByState(productTypeByStateMapping);
      }

      if (Object.keys(productTypeByCityMapping).length > 0) {
        setProductTypesByCity(productTypeByCityMapping);
      }
    }
  }, [jobApprovals]);

  useEffect(() => {
    getApprovalList(
      selectedCity,
      selectedState,
      selectedProductType,
      selectedStore,
      selectedAdminStatus,
      selectedClientStatus,
      selectedCreativeStatus,
      debouncedSearch,
      selectedZone,
    );
  }, [pageSize, page, debouncedSearch]);
  useEffect(() => {
    if (
      isFirstCallRef.current &&
      stateOptions.length &&
      cityOptions.length &&
      storeOptions.length &&
      allProductTypeOptions.length
    ) {
      setSelectedState(["ALL", ...stateOptions.map((x) => x.value)]);
      setSelectedCity(["ALL", ...cityOptions.map((x) => x.value)]);
      setSelectedStore(["ALL", ...storeOptions.map((x) => x.value)]);
      setSelectedZone(["ALL", ...zoneOptions.map((x) => x.value)]);
      setSelectedProductType([
        "ALL",
        ...allProductTypeOptions.map((x) => x.value),
      ]);
      setSelectedAdminStatus(["ALL", 1, -1, 0]);
      setSelectedClientStatus(["ALL", 1, -1, 2, 0]);
      setSelectedCreativeStatus(["ALL", 1, -1, 0]);
      isFirstCallRef.current = false;
    }
  }, [
    stateOptions,
    cityOptions,
    storeOptions,
    zoneOptions,
    allProductTypeOptions,
  ]);

  useEffect(() => {
    const initialSpaces = jobApprovals.map((approval) => ({
      id: approval?.product?._id,
      width: "",
      height: "",
    }));
    setFinalSpaces(initialSpaces);
  }, [jobApprovals]);

  const handlePageChange = async (e, value) => {
    setPage(value);
  };

  const handleStatus = React.useCallback(
    async (id, data, type, rejectionReason = "") => {
      // For approve - direct confirmation
      if (type === "approve") {
        setSelectedRow(data);
        setIsBulkApproval(false);
        setApprovalDialogOpen(true);
      } else if (type === "reject") {
        setSelectedRow(data);
        setRejectionReason("");
        setDialogOpen(true);
      } else if (type === "rework") {
        const result = await Swal.fire({
          title: "Are you sure?",
          text: "This job will be moved to Rework.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Yes, Move to Rework",
          cancelButtonText: "Cancel",
          didOpen: () => {
            const container = document.querySelector(".swal2-container");
            if (container) {
              container.style.zIndex = "99999";
            }
          },
        });

        // ❌ If user cancels → stop here
        if (!result.isConfirmed) return;

        // Prevent socket reload
        updateUserAction(true);

        // Save current state for rollback
        const previousJobApprovals = [...jobApprovals];

        // OPTIMISTIC UPDATE - Mark as rework
        setJobApprovals((prevApprovals) =>
          prevApprovals.map((approval) => {
            if (approval._id === id) {
              return {
                ...approval,
                job: {
                  ...approval.job,
                  status: 1,
                },
              };
            }
            return approval;
          }),
        );

        setAllApprovals((prevApprovals) =>
          prevApprovals.map((approval) => {
            if (approval._id === id) {
              return {
                ...approval,
                job: {
                  ...approval.job,
                  status: 1,
                },
              };
            }
            return approval;
          }),
        );

        try {
          const response = await axios.put(
            `${serverURL}/jobs/updateJob/${data?.job?._id}`,
            { status: 1, rework: true },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (response.data.success) {
            setSnackbar({
              open: true,
              message: "Status changed to Rework successfully",
              severity: "success",
            });
            setOpen(false);

            await getApprovalList(
              selectedCityRef.current,
              selectedStateRef.current,
              selectedProductTypeRef.current,
              selectedStoreRef.current,
              selectedAdminStatusRef.current,
              selectedClientStatusRef.current,
              selectedCreativeStatusRef.current,
              debouncedSearch,
              selectedZoneRef.current,
            );
          } else {
            throw new Error("Failed to update status");
          }
        } catch (error) {
          console.error("Rework error ->", error);

          // rollback jobApprovals
          setJobApprovals(previousJobApprovals);
          setAllApprovals(previousJobApprovals);
          setSnackbar({
            open: true,
            message: "Error while changing status to Rework",
            severity: "error",
          });

          // ✅ RESET THE FLAG ON ERROR TOO
          updateUserAction(false);
        }
      }
    },
    [jobApprovals, token, serverURL, debouncedSearch],
  );

  // UPDATE handleRejectSubmit with Optimistic UI
  const handleRejectSubmit = useCallback(
    (rejectionReason) => {
      if (selectedApprovals.length === 0 && !selectedRow) return;

      // Prevent socket reload
      updateUserAction(true);

      // Save current state for rollback
      const previousJobApprovals = [...jobApprovals];

      //OPTIMISTIC UPDATE
      if (selectedApprovals.length > 0) {
        // Bulk reject
        setJobApprovals((prevApprovals) =>
          prevApprovals.map((approval) => {
            if (selectedApprovals.includes(approval._id)) {
              return {
                ...approval,
                adminStatus: -1,
                rejectionReason: rejectionReason,
                keyAccountManager: {
                  ...approval.keyAccountManager,
                  _id: localStorage.getItem("userId"),
                },
              };
            }
            return approval;
          }),
        );

        setAllApprovals((prevApprovals) =>
          prevApprovals.map((approval) => {
            if (selectedApprovals.includes(approval._id)) {
              return {
                ...approval,
                adminStatus: -1,
                rejectionReason: rejectionReason,
                keyAccountManager: {
                  ...approval.keyAccountManager,
                  _id: localStorage.getItem("userId"),
                },
              };
            }
            return approval;
          }),
        );
      } else {
        // Single reject
        setJobApprovals((prevApprovals) =>
          prevApprovals.map((approval) => {
            if (approval._id === selectedRow._id) {
              return {
                ...approval,
                adminStatus: -1,
                rejectionReason: rejectionReason,
                keyAccountManager: {
                  ...approval.keyAccountManager,
                  _id: localStorage.getItem("userId"),
                },
              };
            }
            return approval;
          }),
        );

        setAllApprovals((prevApprovals) =>
          prevApprovals.map((approval) => {
            if (approval._id === selectedRow._id) {
              return {
                ...approval,
                adminStatus: -1,
                rejectionReason: rejectionReason,
                keyAccountManager: {
                  ...approval.keyAccountManager,
                  _id: localStorage.getItem("userId"),
                },
              };
            }
            return approval;
          }),
        );
      }

      const submitRejection = async () => {
        try {
          const isBulk = selectedApprovals.length > 0;

          const response = await axios.put(
            `${serverURL}/installationPartnerJobApproval/updateApprovalStatus/${
              isBulk ? selectedApprovals[0] : selectedRow._id
            }`,
            {
              ...(isBulk && { approvalIds: selectedApprovals }),
              adminStatus: -1,
              KAMId: localStorage.getItem("userId"),
              rejectionReason: rejectionReason,
              ...(isBulk && { isBulk: true }),
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (response.data.success) {
            const count = isBulk ? selectedApprovals.length : 1;
            setSnackbar({
              open: true,
              message: `${count} job${count > 1 ? "s" : ""} has been successfully rejected.`,
              severity: "success",
            });

            setDialogOpen(false);
            setSelectedApprovals([]);
            setIsSelectAll(false);
            setOpen(false);

            // Update counts
            updateCountsAfterRejection(isBulk ? selectedApprovals.length : 1);

            // ADD THIS REFRESH with debouncedSearch
            await getApprovalList(
              selectedCityRef.current,
              selectedStateRef.current,
              selectedProductTypeRef.current,
              selectedStoreRef.current,
              selectedAdminStatusRef.current,
              selectedClientStatusRef.current,
              selectedCreativeStatusRef.current,
              debouncedSearch,
              selectedZoneRef.current,
            );
          } else {
            throw new Error(
              response.data.message || "Failed to reject the job",
            );
          }
        } catch (error) {
          console.error("Reject error:", error);

          // ROLLBACK
          setJobApprovals(previousJobApprovals);
          setAllApprovals(previousJobApprovals);
          setSnackbar({
            open: true,
            message:
              error.response?.data?.message ||
              "There was an issue rejecting the job(s). Please try again.",
            severity: "error",
          });

          //  Reset the flag on error
          updateUserAction(false);
        } finally {
          setCampaignListLoading(false);
        }
      };
      submitRejection();
    },
    [
      selectedApprovals,
      selectedRow,
      jobApprovals,
      token,
      serverURL,
      debouncedSearch,
    ],
  );

  const handleApprovalSubmit = useCallback(
    async (approvalReason) => {
      if (!isBulkApproval && !selectedRow) return;
      if (isBulkApproval && selectedApprovals.length === 0) return;

      //  Prevent socket reload
      updateUserAction(true);

      // Save current state for rollback
      const previousJobApprovals = [...jobApprovals];

      const userName = localStorage.getItem("name");
      const userId = localStorage.getItem("userId");

      //  Update UI immediately
      if (isBulkApproval) {
        // Bulk approval - update all selected approvals
        setJobApprovals((prevApprovals) =>
          prevApprovals.map((approval) => {
            if (selectedApprovals.includes(approval._id)) {
              return {
                ...approval,
                adminStatus: 1,
                approvalReason: approvalReason,
                keyAccountManager: {
                  ...approval.keyAccountManager,
                  _id: userId,
                  name: userName,
                },
              };
            }
            return approval;
          }),
        );

        setAllApprovals((prevApprovals) =>
          prevApprovals.map((approval) => {
            if (selectedApprovals.includes(approval._id)) {
              return {
                ...approval,
                adminStatus: 1,
                approvalReason: approvalReason,
                keyAccountManager: {
                  ...approval.keyAccountManager,
                  _id: userId,
                  name: userName,
                },
              };
            }
            return approval;
          }),
        );
      } else {
        // Single approval
        setJobApprovals((prevApprovals) =>
          prevApprovals.map((approval) => {
            if (approval._id === selectedRow._id) {
              return {
                ...approval,
                adminStatus: 1,
                approvalReason: approvalReason,
                keyAccountManager: {
                  ...approval.keyAccountManager,
                  _id: userId,
                  name: userName,
                },
              };
            }
            return approval;
          }),
        );

        setAllApprovals((prevApprovals) =>
          prevApprovals.map((approval) => {
            if (approval._id === selectedRow._id) {
              return {
                ...approval,
                adminStatus: 1,
                approvalReason: approvalReason,
                keyAccountManager: {
                  ...approval.keyAccountManager,
                  _id: userId,
                  name: userName,
                },
              };
            }
            return approval;
          }),
        );
      }

      // Update counts
      if (isBulkApproval) {
        updateCountsAfterApproval(selectedApprovals.length);
      } else {
        updateCountsAfterApproval(1);
      }

      try {
        if (isBulkApproval) {
          const response = await axios.put(
            `${serverURL}/installationPartnerJobApproval/updateApprovalStatus/${selectedApprovals[0]}`,
            {
              approvalIds: selectedApprovals,
              adminStatus: 1,
              KAMId: userId,
              approvalReason: approvalReason,
              isBulk: true,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (response.data.success) {
            const count = selectedApprovals.length;
            setSnackbar({
              open: true,
              message: `${count} job${
                count > 1 ? "s" : ""
              } has been successfully approved.`,
              severity: "success",
            });
            setApprovalDialogOpen(false);
            setSelectedApprovals([]);
            setIsSelectAll(false);
            setIsBulkApproval(false);
          } else {
            throw new Error(
              response.data.message || "Failed to approve the jobs",
            );
          }
        } else {
          const response = await axios.put(
            `${serverURL}/installationPartnerJobApproval/updateApprovalStatus/${selectedRow._id}`,
            {
              adminStatus: 1,
              KAMId: localStorage.getItem("userId"),
              approvalReason: approvalReason,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (response.data.success) {
            setSnackbar({
              open: true,
              message: "Product has been successfully approved.",
              severity: "success",
            });

            setApprovalDialogOpen(false);
            setSelectedRow("");
            setOpen(false);
          } else {
            throw new Error(
              response.data.message || "Failed to approve the job",
            );
          }
        }
      } catch (error) {
        console.error("Approval error:", error);

        // ROLLBACK - Revert to previous state on error
        setJobApprovals(previousJobApprovals);
        setAllApprovals(previousJobApprovals);

        // Rollback counts
        if (isBulkApproval) {
          updateCountsAfterApproval(-selectedApprovals.length);
        } else {
          updateCountsAfterApproval(-1);
        }

        setSnackbar({
          open: true,
          message:
            error.response?.data?.message ||
            "There was an issue approving the product. Please try again.",
          severity: "error",
        });
      } finally {
        setCampaignListLoading(false);
        updateUserAction(false);
      }
    },
    [
      isBulkApproval,
      selectedApprovals,
      selectedRow,
      jobApprovals,
      token,
      serverURL,
    ],
  );

  // UPDATED: handleProductChange with Optimistic UI
  const handleProductChange = useCallback(
    async (productId, productType, approval) => {
      const price = approval?.campaignId?.rfpId?.products?.find(
        (p) => p.productType === productType,
      )?.costCalculator?.totalCostOfProduct;

      // Save current state for rollback
      const previousJobApprovals = [...jobApprovals];

      //  OPTIMISTIC UPDATE - Update both states
      const updateApproval = (approvalItem) => {
        if (approvalItem.product._id === productId) {
          return {
            ...approvalItem,
            product: {
              ...approvalItem.product,
              productType: productType,
              price: price || approvalItem.product.price,
            },
          };
        }
        return approvalItem;
      };

      setJobApprovals((prevApprovals) => prevApprovals.map(updateApproval));
      setAllApprovals((prevApprovals) => prevApprovals.map(updateApproval));

      try {
        await fetch(`${serverURL}/product/updateFinalProduct/${productId}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            productType: productType,
            price: price,
          }),
        });

        setSnackbar({
          open: true,
          message: "Product type updated successfully",
          severity: "success",
        });
      } catch (error) {
        console.error("Product update error", error);

        // ROLLBACK
        setJobApprovals(previousJobApprovals);
        setAllApprovals(previousJobApprovals);
        setSnackbar({
          open: true,
          message: "Failed to update product type",
          severity: "error",
        });
      }
    },
    [jobApprovals, token, serverURL],
  );

  const handleReportOpen = useCallback((approval) => {
    setOpen(true);
    setCurrentApproval(approval);
  }, []);

  const handleClose = useCallback(() => setOpen(false), []);

  const handleClientApprovalClose = useCallback(
    () => setClientApprovalOpen(false),
    [],
  );

  const handleCreativeOpen = useCallback((approval) => {
    // if (approval?.adminStatus == 1 && approval?.clientStatus == 1) {
    //   return;
    // }
    setSelectedApproval(approval);
    // Prefill title + file here
    setCreativeTitle(approval.job?.adaptationText || "");
    setCreativeFile(approval.job?.adaptationImage || "");

    setOpenCreative(true);
  }, []);

  const handleCreativeSave = useCallback(async () => {
    // Save previous state for rollback
    const previousJobApprovals = [...jobApprovals];
    const previousCreativeFile = creativeFile;
    const previousCreativeTitle = creativeTitle;

    setUploadLoading(true);

    //  OPTIMISTIC UPDATE - Update UI immediately
    setJobApprovals((prevApprovals) =>
      prevApprovals.map((approval) => {
        if (approval.jobId === selectedApproval.jobId) {
          return {
            ...approval,
            job: {
              ...approval.job,
              adaptationText: creativeTitle,
              adaptationImage: creativeFile,
            },
          };
        }
        return approval;
      }),
    );

    setAllApprovals((prevApprovals) =>
      prevApprovals.map((approval) => {
        if (approval.jobId === selectedApproval.jobId) {
          return {
            ...approval,
            job: {
              ...approval.job,
              adaptationText: creativeTitle,
              adaptationImage: creativeFile,
            },
          };
        }
        return approval;
      }),
    );

    setSnackbar({
      open: true,
      message: "Creative uploaded successfully",
      severity: "success",
    });

    try {
      const token = localStorage.getItem("token");

      const payload = {
        adaptationText: creativeTitle,
        adaptationImage: creativeFile,
      };

      await axios.put(
        `${process.env.REACT_APP_URL}/jobs/updateJob/${selectedApproval.jobId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setOpenCreative(false);
      setRefreshCreative((prev) => !prev);
    } catch (error) {
      console.error("Error updating job:", error);

      // ROLLBACK - Revert UI on error
      setJobApprovals((prevApprovals) =>
        prevApprovals.map((approval) => {
          if (approval.jobId === selectedApproval.jobId) {
            return {
              ...approval,
              job: {
                ...approval.job,
                adaptationText: previousCreativeTitle,
                adaptationImage: previousCreativeFile,
              },
            };
          }
          return approval;
        }),
      );

      setAllApprovals((prevApprovals) =>
        prevApprovals.map((approval) => {
          if (approval.jobId === selectedApproval.jobId) {
            return {
              ...approval,
              job: {
                ...approval.job,
                adaptationText: previousCreativeTitle,
                adaptationImage: previousCreativeFile,
              },
            };
          }
          return approval;
        }),
      );
      setSnackbar({
        open: true,
        message: "Failed to upload creative",
        severity: "error",
      });
    } finally {
      setUploadLoading(false);
    }
  }, [
    selectedApproval,
    creativeTitle,
    creativeFile,
    jobApprovals,
    debouncedSearch,
  ]);

  const handleDeleteUpload = useCallback(async () => {
    let previousCreativeFile = "";
    let previousJobApprovals = [];

    try {
      const token = localStorage.getItem("token");

      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to delete this image?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it",
        confirmButtonColor: "#d33",
        customClass: {
          container: "my-swal",
        },
      });

      if (!result.isConfirmed) return;

      previousCreativeFile = creativeFile || "";
      previousJobApprovals = [...jobApprovals];

      // OPTIMISTIC UPDATE - Remove image from UI immediately
      setJobApprovals((prevApprovals) =>
        prevApprovals.map((approval) => {
          if (approval.jobId === selectedApproval.jobId) {
            return {
              ...approval,
              job: {
                ...approval.job,
                adaptationImage: "",
              },
            };
          }
          return approval;
        }),
      );

      setAllApprovals((prevApprovals) =>
        prevApprovals.map((approval) => {
          if (approval.jobId === selectedApproval.jobId) {
            return {
              ...approval,
              job: {
                ...approval.job,
                adaptationImage: "",
              },
            };
          }
          return approval;
        }),
      );

      setCreativeFile("");
      setSelectedApproval((prev) => ({
        ...prev,
        job: {
          ...prev.job,
          adaptationImage: "",
        },
      }));

      setSnackbar({
        open: true,
        message: "Image deleted successfully",
        severity: "success",
      });

      if (previousCreativeFile) {
        await axios.post(
          `${serverURL}/deleteUpload`,
          { keys: previousCreativeFile },
          { headers: { Authorization: `Bearer ${token}` } },
        );
      }

      await axios.put(
        `${process.env.REACT_APP_URL}/jobs/updateJob/${selectedApproval.jobId}`,
        { adaptationImage: "" },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      setOpenCreative(false);
    } catch (error) {
      console.error("Error deleting image:", error);

      const previousImage = previousCreativeFile || "";

      setJobApprovals((prevApprovals) =>
        prevApprovals.map((approval) => {
          if (approval.jobId === selectedApproval.jobId) {
            return {
              ...approval,
              job: {
                ...approval.job,
                adaptationImage: previousImage,
              },
            };
          }
          return approval;
        }),
      );

      setAllApprovals((prevApprovals) =>
        prevApprovals.map((approval) => {
          if (approval.jobId === selectedApproval.jobId) {
            return {
              ...approval,
              job: {
                ...approval.job,
                adaptationImage: previousImage,
              },
            };
          }
          return approval;
        }),
      );

      setCreativeFile(previousImage);
      setSelectedApproval((prev) => ({
        ...prev,
        job: {
          ...prev.job,
          adaptationImage: previousImage,
        },
      }));

      setSnackbar({
        open: true,
        message: "Failed to delete image",
        severity: "error",
      });
    }
  }, [
    selectedApproval,
    creativeFile,
    jobApprovals,
    serverURL,
    debouncedSearch,
  ]);

  const totalRecceArea = useMemo(() => {
    return (
      jobApprovals
        ?.filter(
          (job) =>
            job?.adminStatus !== -1 &&
            job?.clientStatus !== -1 &&
            job?.clientStatus !== 2,
        )
        ?.reduce((sum, approval) => {
          const recceHeight =
            approval?.job?.productDimensionsAfterRecce?.height || 0;

          const recceWidth =
            approval?.job?.productDimensionsAfterRecce?.width || 0;

          return sum + recceHeight * recceWidth;
        }, 0) || 0
    );
  }, [jobApprovals]);

  const handleVendorDocumentChange = useCallback(
    async (e, approval) => {
      const file = e.target.files[0];

      if (!file) return;

      if (file.type !== "application/pdf") {
        alert("Only PDF allowed");
        return;
      }

      // Save previous file URL for rollback
      const previousFileUrl = approval?.job?.vendorDocumentFile || "";

      // Save current state for rollback
      const previousJobApprovals = [...jobApprovals];

      setUploadLoading(true);

      try {
        const token = localStorage.getItem("token");

        // STEP 1 — Upload file to /upload API
        const uploadFormData = new FormData();
        uploadFormData.append("files", file);

        const uploadResponse = await axios.post(
          `${process.env.REACT_APP_URL}/upload`,
          uploadFormData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (!uploadResponse.data.success) {
          throw new Error("Upload failed");
        }

        const uploadedUrl = uploadResponse.data.data[0];

        // Update UI immediately
        setJobApprovals((prevApprovals) =>
          prevApprovals.map((item) => {
            if (item._id === approval._id) {
              return {
                ...item,
                job: {
                  ...item.job,
                  vendorDocumentFile: uploadedUrl,
                },
              };
            }
            return item;
          }),
        );

        setAllApprovals((prevApprovals) =>
          prevApprovals.map((item) => {
            if (item._id === approval._id) {
              return {
                ...item,
                job: {
                  ...item.job,
                  vendorDocumentFile: uploadedUrl,
                },
              };
            }
            return item;
          }),
        );

        setSnackbar({
          open: true,
          message: "PDF uploaded successfully",
          severity: "success",
        });

        await axios.put(
          `${process.env.REACT_APP_URL}/jobs/updateJob/${approval?.job?._id}`,
          { vendorDocumentFile: uploadedUrl },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
      } catch (error) {
        console.error("Upload error:", error);

        // ROLLBACK - Revert UI on error
        setJobApprovals((prevApprovals) =>
          prevApprovals.map((item) => {
            if (item._id === approval._id) {
              return {
                ...item,
                job: { ...item.job, vendorDocumentFile: previousFileUrl },
              };
            }
            return item;
          }),
        );

        setAllApprovals((prevApprovals) =>
          prevApprovals.map((item) => {
            if (item._id === approval._id) {
              return {
                ...item,
                job: { ...item.job, vendorDocumentFile: previousFileUrl },
              };
            }
            return item;
          }),
        );
        setSnackbar({
          open: true,
          message: "Failed to upload PDF",
          severity: "error",
        });
      } finally {
        setUploadLoading(false);
      }
    },
    [jobApprovals],
  );

  const fetchItemMasterProductList = useCallback(
    async (campaignId) => {
      try {
        const res = await fetch(
          `${serverURL}/itemMaster/all-product-type?campaignId=${campaignId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          },
        );

        const data = await res.json();

        return data?.products || [];
      } catch (error) {
        console.error("Error fetching item master product list:", error);
        return [];
      }
    },
    [serverURL],
  );

  const handleAddRemark = useCallback((approval) => {
    setSelectedApproval(approval);
    setRemarkText("");
    setIsEditingRemark(true);
    setOpenRemarkModal(true);
  }, []);

  const handleViewRemark = useCallback((approval) => {
    setSelectedApproval(approval);
    setRemarkText(approval?.job?.remarks || "");
    setIsEditingRemark(false);
    setOpenRemarkModal(true);
  }, []);

  const handleEditRemark = useCallback(() => {
    setIsEditingRemark(true);
  }, []);

  const handleRemarkSave = useCallback(
    async (approval, newRemark) => {
      if (!newRemark?.trim()) return;

      const previousJobApprovals = [...jobApprovals];

      // Remove remark immediately
      setJobApprovals((prevApprovals) =>
        prevApprovals.map((approval) => {
          if (approval._id === selectedApproval?._id) {
            return {
              ...approval,
              job: {
                ...approval.job,
                remarks: newRemark.trim(),
              },
            };
          }
          return approval;
        }),
      );

      setAllApprovals((prevApprovals) =>
        prevApprovals.map((item) => {
          if (item._id === approval?._id) {
            return {
              ...item,
              job: {
                ...item.job,
                remarks: newRemark.trim(),
              },
            };
          }
          return item;
        }),
      );

      try {
        const token = localStorage.getItem("token");
        await axios.put(
          `${process.env.REACT_APP_URL}/jobs/updateJob/${approval?.job?._id}`,
          { remarks: newRemark.trim() },
          { headers: { Authorization: `Bearer ${token}` } },
        );

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Remark updated successfully",
          timer: 1500,
          showConfirmButton: false,
        });
        setIsEditingRemark(false);
        setOpenRemarkModal(false);
      } catch (error) {
        console.error(error);
        // Rollback on error
        setJobApprovals(previousJobApprovals);
        setAllApprovals(previousJobApprovals);
        throw error;
      }
    },
    [jobApprovals],
  );

  const handleRemarkDelete = useCallback(
    async (approval) => {
      const previousJobApprovals = [...jobApprovals];

      // Optimistic update
      setJobApprovals((prevApprovals) =>
        prevApprovals.map((item) => {
          if (item._id === approval?._id) {
            return {
              ...item,
              job: {
                ...item.job,
                remarks: "",
              },
            };
          }
          return item;
        }),
      );

      setAllApprovals((prevApprovals) =>
        prevApprovals.map((item) => {
          if (item._id === approval?._id) {
            return {
              ...item,
              job: {
                ...item.job,
                remarks: "",
              },
            };
          }
          return item;
        }),
      );

      try {
        const token = localStorage.getItem("token");
        await axios.put(
          `${process.env.REACT_APP_URL}/jobs/updateJob/${approval?.job?._id}`,
          { remarks: "" },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        Swal.fire({
          icon: "success",
          title: "Deleted",
          text: "Remark deleted successfully",
          timer: 1500,
          showConfirmButton: false,
        });
        setRemarkText("");
        setIsEditingRemark(false);
        setOpenRemarkModal(false);
      } catch (error) {
        console.error(error);
        setJobApprovals(previousJobApprovals);
        setAllApprovals(previousJobApprovals);
        throw error;
      }
    },
    [jobApprovals],
  );

  const handleViewReferenceImage = useCallback((approval) => {
    setReferenceImage(approval?.job?.clientSideAdaptationImage);
    setOpenReferenceImageModal(true);
  }, []);

  useEffect(() => {
    const loadProducts = async () => {
      const products = await fetchItemMasterProductList(id);
      setProductList(products);
    };
    loadProducts();
  }, [id, fetchItemMasterProductList]);

  const productOptions = useMemo(() => {
    return (
      productList?.map((product) => ({
        value: product,
        label: product,
      })) || []
    );
  }, [productList]);

  useEffect(() => {
    const timer = setTimeout(() => {
      const searchText = search.toLowerCase();
      setDebouncedSearch(searchText);
      if (!searchText) {
        setJobApprovals(allApprovals);
        return;
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [search, allApprovals]);

  const renderedRows = useMemo(() => {
    return jobApprovals?.map((approval) => {
      const isSelectable = canSelectApproval(approval);
      const isSelected = selectedApprovals.includes(approval._id);
      const comment = getCommentForStatus(approval);
      const hasComment = comment && comment.trim() !== "";

      return (
        <TableRow
          hover
          key={approval?._id}
          tabIndex={-1}
          sx={{
            cursor: "pointer",
            height: "60px",
            backgroundColor:
              approval.clientStatus !== 0 // check client Approval is given or not
                ? approval.clientStatus === 1 // client approval is yes
                  ? "rgba(0, 255, 0, 0.1)"
                  : approval.clientStatus === -1 // client approval is ignore
                    ? "rgba(255, 0, 0, 0.1)"
                    : approval.clientStatus === 2 // client approval is holdOn
                      ? "rgba(255, 255, 0, 0.2)"
                      : "transparent"
                : approval.adminStatus === 1
                  ? "rgba(0, 255, 0, 0.1)"
                  : approval.adminStatus === -1
                    ? "rgba(255, 0, 0, 0.1)"
                    : "transparent",
          }}
        >
          {/* Selection checkbox */}
          <TableCell
            align="center"
            sx={{
              position: "sticky",
              left: 0,
              background: "#fff",
              zIndex: 9,
              borderRight: "1px solid #ddd",
              padding: "4px 8px",
            }}
          >
            <Checkbox
              checked={isSelected}
              onChange={() => handleSelectApproval(approval._id)}
              disabled={!isSelectable}
              icon={<CheckBoxOutlineBlankIcon />}
              checkedIcon={<CheckBoxIcon />}
            />{" "}
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
            }}
          >
            <div className={styles.tableRow}>
              {approval?.job?.state || "NA"}
            </div>
          </TableCell>
          <TableCell sx={{ padding: "4px 8px" }}>
            <span className={styles.tableRow}>
              {approval?.job?.city || "NA"}
            </span>
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
            }}
          >
            <Tooltip
              title={
                approval?.job?.address?.length > 17
                  ? approval?.job?.address
                  : ""
              }
              arrow
            >
              <span
                className={styles.tableRow}
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "150px",
                  fontSize: "13px",
                }}
              >
                {approval?.job?.address?.length > 17
                  ? `${approval?.job?.address.substring(0, 17)}...`
                  : approval?.job?.address || "NA"}
              </span>
            </Tooltip>
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
            }}
          >
            <Tooltip
              title={
                approval?.job?.storeName?.length > 20
                  ? approval?.job?.storeName
                  : ""
              }
              arrow
            >
              <span
                className={styles.tableRow}
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "150px",
                  fontSize: "13px",
                }}
              >
                {approval?.job?.storeName?.length > 20
                  ? `${approval?.job?.storeName.substring(0, 20)}...`
                  : approval?.job?.storeName || "NA"}
              </span>
            </Tooltip>
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
            }}
          >
            <div className={styles.tableRow}>{approval?.job?.zone || "NA"}</div>
          </TableCell>

          <TableCell sx={{ padding: "4px 8px" }}>
            <div className={styles.tableRow}>
              {Number(
                approval?.job?.productDimensionsAfterRecce?.width || 0,
              ).toFixed(2)}
            </div>
          </TableCell>
          {/* <TableCell sx={{ padding: "4px 8px" }}>
                              <div className={styles.tableRow}>
                                {approval?.job?.productDimensionsAfterRecce
                                  ?.width || "0"}
                              </div>
                            </TableCell> */}
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight:
                localStorage.getItem("role") !== "-1"
                  ? "1px solid #ddd"
                  : "none",
            }}
          >
            <div className={styles.tableRow}>
              {Number(
                approval?.job?.productDimensionsAfterRecce?.height || "0",
              ).toFixed(2)}
            </div>
          </TableCell>
          {localStorage.getItem("role") == -1 && (
            <TableCell
              sx={{
                padding: "4px 8px",
                borderRight: "1px solid #ddd",
              }}
            >
              <div
                className={`${styles.tableRow}  flex items-center justify-center gap-2`}
              >
                {(() => {
                  const originalHeight = approval?.product?.productHeight || 0;
                  const originalWidth = approval?.product?.productWidth || 0;
                  const recceHeight =
                    approval?.job?.productDimensionsAfterRecce?.height || 0;
                  const recceWidth =
                    approval?.job?.productDimensionsAfterRecce?.width || 0;

                  const originalArea = originalHeight * originalWidth;
                  const recceArea = (recceHeight * recceWidth).toFixed(2) || 0;

                  const areaDifference = (recceArea - originalArea).toFixed(2);

                  const signed = areaDifference > 0 ? "+" : "-";

                  return (
                    <>
                      {recceArea}

                      {/* {areaDifference >= 0 ? (
                      <Tooltip
                        title={
                          areaDifference.toString().length > 5
                            ? `${signed}${areaDifference}`
                            : ""
                        }
                        arrow
                      >
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            cursor:
                              areaDifference.toString().length > 5
                                ? "pointer"
                                : "default",
                          }}
                        >
                          <ArrowDropUpIcon sx={{ color: "#00C853" }} />
                          <span
                            style={{
                              color: "green",
                              fontSize: "10px",
                              marginLeft: "2px",
                            }}
                          >
                            {areaDifference.toString().length > 7
                              ? `${signed}${areaDifference
                                  .toString()
                                  .slice(0, 5)}...`
                              : `${signed}${areaDifference}`}
                          </span>
                        </span>
                      </Tooltip>
                    ) : (
                      <Tooltip
                        title={
                          areaDifference.toString().length > 5
                            ? `${signed}${areaDifference}`
                            : ""
                        }
                        arrow
                      >
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            cursor:
                              areaDifference.toString().length > 7
                                ? "pointer"
                                : "default",
                          }}
                        >
                          <PolygonDown color="red" />
                          <span
                            style={{
                              color: "red",
                              fontSize: "10px",
                              marginLeft: "2px",
                            }}
                          >
                            {areaDifference.toString().length > 7
                              ? `${areaDifference.toString().slice(0, 5)}...`
                              : `${areaDifference}`}
                          </span>
                        </span>
                      </Tooltip>
                    )} */}
                    </>
                  );
                })()}
              </div>
            </TableCell>
          )}
          {/* <TableCell
                              sx={{
                                padding: "4px 8px",
                                borderRight: "1px solid #ddd",
                                width: "160px",
                              }}
                            >
                              <Tooltip
                                title={
                                  approval?.product?.productType?.length > 17
                                    ? approval.product.productType
                                    : ""
                                }
                                arrow
                                placement="top"
                              >
                                <span
                                  className={styles.tableRow}
                                  style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: "110px",
                                    fontSize: "13px",
                                    display: "inline-block",
                                  }}
                                >
                                  {approval?.product?.productType
                                    ? approval.product.productType.length > 17
                                      ? `${approval.product.productType.substring(
                                          0,
                                          17,
                                        )}...`
                                      : approval.product.productType
                                    : "NA"}
                                </span>
                              </Tooltip>
                            </TableCell> */}
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
              width: "160px",
            }}
          >
            <Tooltip
              title={
                approval?.clientStatus != 0 || approval.adminStatus == -1
                  ? "Product cannot be changed after client approval or admin rejection of the job."
                  : ""
              }
              arrow
              placement="top"
            >
              <span
                style={{
                  display: "inline-block",
                  width: "100%",
                }}
              >
                <GlobalDropdownField
                  variant="compact"
                  name="productType"
                  search
                  height="40px"
                  disabled={
                    approval?.clientStatus != 0 || approval.adminStatus == -1
                  }
                  value={approval?.product?.productType || ""}
                  placeholder="Select Product"
                  options={productOptions}
                  onChange={(e) =>
                    handleProductChange(
                      approval?.product?._id,
                      e.target.value,
                      approval,
                    )
                  }
                  renderValueFn={(selected) => (
                    <span
                      style={{
                        fontSize: "0.75rem",
                      }}
                    >
                      {selected || "Select Product"}
                    </span>
                  )}
                  useNewStyles
                />
              </span>
            </Tooltip>
          </TableCell>
          {localStorage.getItem("role") == -1 && (
            <TableCell
              sx={{
                padding: "4px 8px",
                borderRight: "1px solid #ddd",
                width: "160px",
              }}
            >
              <div
                className={`${styles.tableRow} w-[100px] flex items-center justify-center gap-2 `}
              >
                {(() => {
                  const originalHeight = approval?.product?.productHeight || 0;
                  const originalWidth = approval?.product?.productWidth || 0;
                  const recceHeight =
                    approval?.job?.productDimensionsAfterRecce?.height || 0;
                  const recceWidth =
                    approval?.job?.productDimensionsAfterRecce?.width || 0;

                  const originalAmount =
                    originalHeight * originalWidth * approval.product?.price;
                  const recceAmount =
                    (
                      recceHeight *
                      recceWidth *
                      approval.product?.price
                    ).toFixed(2) || 0;

                  // const areaDifference =
                  //   originalAmount - recceAmount;
                  const areaDifference = (recceAmount - originalAmount).toFixed(
                    2,
                  );
                  const signed = areaDifference > 0 ? "+" : "-";

                  return (
                    <>
                      {recceAmount ? (
                        <Tooltip title={`₹ ${recceAmount}`}>
                          <span>
                            {recceAmount.toString().length > 8
                              ? `₹ ${recceAmount.toString().slice(0, 8)}...`
                              : `₹ ${recceAmount}`}
                          </span>
                        </Tooltip>
                      ) : (
                        "0"
                      )}
                      {/* {areaDifference >= 0 ? (
                      <Tooltip
                        title={
                          areaDifference.toString().length > 5
                            ? `${signed} ₹${areaDifference}`
                            : ""
                        }
                        arrow
                      >
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            cursor:
                              areaDifference.toString().length > 5
                                ? "pointer"
                                : "default",
                          }}
                        >
                          <ArrowDropUpIcon sx={{ color: "#00C853" }} />
                          <span
                            style={{
                              color: "green",
                              fontSize: "10px",
                              marginLeft: "2px",
                            }}
                          >
                            {`${signed} ₹${
                              areaDifference.toString().length > 5
                                ? areaDifference.toString().slice(0, 5) + "..."
                                : areaDifference
                            }`}
                          </span>
                        </span>
                      </Tooltip>
                    ) : (
                      <Tooltip
                        title={
                          Math.abs(areaDifference).toString().length > 5
                            ? `${signed} ₹${Math.abs(areaDifference)}`
                            : ""
                        }
                        arrow
                      >
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            cursor:
                              Math.abs(areaDifference).toString().length > 5
                                ? "pointer"
                                : "default",
                          }}
                        >
                          <PolygonDown color="red" />

                          <span
                            style={{
                              color: "red",
                              fontSize: "10px",
                              marginLeft: "2px",
                            }}
                          >
                            {`${signed} ₹${
                              Math.abs(areaDifference).toString().length > 5
                                ? Math.abs(areaDifference)
                                    .toString()
                                    .slice(0, 4) + "..."
                                : Math.abs(areaDifference)
                            }`}
                          </span>
                        </span>
                      </Tooltip>
                    )} */}
                    </>
                  );
                })()}
              </div>
            </TableCell>
          )}
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
              textAlign: "center",
            }}
          >
            <div
              style={{ margin: "0.1rem" }}
              onClick={() => handleReportOpen(approval)}
              className="flex justify-center items-center"
              // className="text-blue-500 underline"
            >
              <ReportIcon width={28} height={36} />
            </div>
          </TableCell>
          {localStorage.getItem("role") != 7 && (
            <TableCell
              sx={{
                padding: "4px 8px",
                borderRight: "1px solid #ddd",
              }}
              style={{
                opacity:
                  approval.adminStatus == 1 ||
                  approval.adminStatus == -1 ||
                  approval.job.status == 1
                    ? 0.5
                    : 1,
                pointerEvents:
                  approval.adminStatus == 1 ||
                  approval.adminStatus == -1 ||
                  approval.job.status == 1
                    ? "none"
                    : "auto",
              }}
            >
              <div className="flex justify-center items-center gap-2">
                <GlobalButton
                  variant="primary"
                  size="small"
                  onClick={() => {
                    handleStatus(approval?._id, approval, "approve");
                  }}
                  disabled={
                    validationErrors[approval?.product?._id]?.required ||
                    validationErrors[approval?.product?._id]?.exceedsWidth ||
                    validationErrors[approval?.product?._id]?.exceedsHeight
                  }
                  style={{ margin: "0.2rem" }}
                >
                  APPROVE
                </GlobalButton>

                <GlobalButton
                  variant="warning"
                  size="small"
                  onClick={() => handleStatus(approval._id, approval, "reject")}
                  style={{ margin: "0.2rem" }}
                >
                  REJECT
                </GlobalButton>
                <GlobalButton
                  variant="primary"
                  size="small"
                  onClick={() => handleStatus(approval._id, approval, "rework")}
                  style={{ margin: "0.2rem" }}
                >
                  REWORK
                </GlobalButton>
              </div>
            </TableCell>
          )}
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
            }}
          >
            <Tooltip
              title={
                approval.adminStatus === -1
                  ? `Rejection Reason: ${
                      approval.rejectionReason || "Not provided"
                    }`
                  : approval.adminStatus === 1
                    ? `Approval Reason: ${
                        approval.approvalReason || "Not provided"
                      }`
                    : ""
              }
              arrow
              placement="top"
            >
              <Chip
                label={
                  approval.adminStatus === 0
                    ? "Pending"
                    : approval.adminStatus === 1
                      ? "Approved"
                      : "Rejected"
                }
                sx={{
                  backgroundColor:
                    approval.adminStatus === 0
                      ? "#D0F4FF"
                      : approval.adminStatus === 1
                        ? "#DDFFD3"
                        : "#FFDFDF",
                  color:
                    approval.adminStatus === 0
                      ? "#093EBC"
                      : approval.adminStatus === 1
                        ? "#358C09"
                        : "#8C0909",
                }}
              />
            </Tooltip>
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
            }}
          >
            <Tooltip
              title={
                approval.clientStatus === -1
                  ? `Reason: ${approval.clientrejectionReason}`
                  : ""
              }
              arrow
              placement="top"
            >
              <Chip
                label={
                  approval.clientStatus === 0
                    ? "Pending"
                    : approval.clientStatus === 1
                      ? "Approved"
                      : approval.clientStatus === -1
                        ? "Ignore"
                        : "Hold On"
                }
                sx={{
                  backgroundColor:
                    approval.clientStatus === 0
                      ? "#D0F4FF" // Light Blue for Pending
                      : approval.clientStatus === 1
                        ? "#DDFFD3" // Light Green for Approved
                        : approval.clientStatus === 2
                          ? "#FFF3CD" // Light Yellow for Hold On
                          : "#FFDFDF", // Light Red for Rejected
                  color:
                    approval.clientStatus === 0
                      ? "#093EBC" // Dark Blue for Pending
                      : approval.clientStatus === 1
                        ? "#358C09" // Dark Green for Approved
                        : approval.clientStatus === 2
                          ? "#8C6D09" // Dark Yellow for Hold On
                          : "#8C0909", // Dark Red for Rejected
                }}
              />
            </Tooltip>
          </TableCell>
          <TableCell sx={{ padding: "4px 8px" }}>
            <div className={styles.tableRow}>
              {approval?.keyAccountManager?.name
                ? approval.keyAccountManager.name.charAt(0).toUpperCase() +
                  approval.keyAccountManager.name.slice(1)
                : "Not Available"}
            </div>
          </TableCell>
          <TableCell sx={{ padding: "4px 8px" }}>
            <Tooltip
              title={CapitalizeFirstLetter(approval?.client?.name) || "NA"}
              arrow
            >
              <div className={styles.tableRow}>
                {(CapitalizeFirstLetter(approval?.client?.name?.slice(0, 5)) ||
                  "NA") + (approval?.client?.name?.length > 5 ? "..." : "")}
              </div>
            </Tooltip>
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
              borderLeft: "1px solid #ddd",
              textAlign: "center",
              minWidth: "120px",
            }}
          >
            <div className="flex items-center justify-center gap-2">
              {!approval?.job?.remarks ? (
                <Tooltip title="Add Remark">
                  <IconButton
                    size="small"
                    onClick={() => handleAddRemark(approval)}
                    sx={{
                      color: "#16a34a",
                      background: "#dcfce7",
                      "&:hover": {
                        background: "#bbf7d0",
                      },
                    }}
                  >
                    <AddOutlined fontSize="small" />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="View Remark">
                  <IconButton
                    size="small"
                    onClick={() => handleViewRemark(approval)}
                    sx={{
                      color: "#2563eb",
                      background: "#dbeafe",
                      "&:hover": {
                        background: "#bfdbfe",
                      },
                    }}
                  >
                    <VisibilityOutlined fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
              maxWidth: "200px",
            }}
          >
            <Tooltip title={comment || "No comments"} arrow placement="top">
              <div
                className={`${styles.tableRow} flex items-center ${
                  hasComment ? "text-gray-700" : "text-gray-400"
                }`}
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "180px",
                  fontSize: "13px",
                }}
              >
                {hasComment ? (
                  <>
                    {comment.length > 25
                      ? `${comment.substring(0, 25)}...`
                      : comment}
                  </>
                ) : (
                  "No comments"
                )}
              </div>
            </Tooltip>
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
              borderLeft: "1px solid #ddd",
              textAlign: "center",
            }}
          >
            <div
              style={{ margin: "0.1rem" }}
              // className={`text-blue-500 ${approval.clientStatus == 1 && approval.adminStatus == 1 ? "cursor-not-allowed" : "cursor-pointer"}`}
              className={`text-blue-500 cursor-pointer}`}
            >
              {!approval.job.adaptationImage ? (
                <Tooltip
                  title={
                    approval.clientStatus === 1
                      ? "Upload Creative"
                      : "Creative can only be uploaded after client approval"
                  }
                >
                  <p
                    onClick={() => {
                      if (approval.clientStatus == 1)
                        handleCreativeOpen(approval);
                    }}
                    className={
                      approval.clientStatus === 1
                        ? "cursor-pointer"
                        : "cursor-not-allowed"
                    }
                  >
                    Upload
                  </p>
                </Tooltip>
              ) : (
                <div className="flex justify-center items-center gap-1">
                  {approval?.job?.clientCreativeStatus === 1 ? (
                    <Tooltip title="Approved">
                      <CheckCircleOutlineIcon
                        sx={{
                          color: "#16a34a",
                          fontSize: 18,
                        }}
                      />
                    </Tooltip>
                  ) : approval?.job?.clientCreativeStatus === -1 ? (
                    <Tooltip title="Rejected">
                      <CancelOutlinedIcon
                        sx={{
                          color: "#dc2626",
                          fontSize: 18,
                        }}
                      />
                    </Tooltip>
                  ) : (
                    <Tooltip title="Pending">
                      <HourglassEmptyIcon
                        sx={{
                          color: "#f59e0b",
                          fontSize: 18,
                        }}
                      />
                    </Tooltip>
                  )}
                  <ImageOutlined
                    fontSize="small"
                    className="cursor-pointer text-gray-500 hover:text-black"
                    onMouseEnter={(e) => {
                      setHoveredImageAdmin(approval.job.adaptationImage);
                      setAnchorElAdmin(e.currentTarget);
                    }}
                    onMouseLeave={() => {
                      setHoveredImageAdmin(null);
                      setAnchorElAdmin(null);
                    }}
                  />
                  <Tooltip
                    title={
                      approval.clientStatus === 1
                        ? "Update Creative"
                        : "Creative can only be updated after client approval"
                    }
                  >
                    <p
                      onClick={() => {
                        if (approval.clientStatus == 1) {
                          handleCreativeOpen(approval);
                        }
                      }}
                      className={
                        approval.clientStatus == 1
                          ? "cursor-pointer"
                          : "cursor-not-allowed"
                      }
                    >
                      Update
                    </p>
                  </Tooltip>
                </div>
              )}
            </div>
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
              borderLeft: "1px solid #ddd",
              textAlign: "center",
            }}
          >
            <div style={{ margin: "0.1rem" }} className="text-blue-500">
              {!approval.job.clientSideAdaptationImage ? (
                <p>-</p>
              ) : (
                <div className="flex justify-center items-center">
                  <ImageOutlined
                    fontSize="small"
                    className="cursor-pointer text-gray-500 hover:text-black"
                    onClick={() => handleViewReferenceImage(approval)}
                    onMouseEnter={(e) => {
                      setHoveredImage(approval.job.clientSideAdaptationImage);
                      setAnchorEl(e.currentTarget);
                    }}
                    onMouseLeave={() => {
                      setHoveredImage(null);
                      setAnchorEl(null);
                    }}
                  />
                </div>
              )}
            </div>
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
              borderLeft: "1px solid #ddd",
              textAlign: "center",
            }}
          >
            <Tooltip
              title={
                approval?.job?.creativeDescription?.length > 17
                  ? approval?.job?.creativeDescription
                  : ""
              }
              arrow
            >
              <span
                className={styles.tableRow}
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "150px",
                  fontSize: "13px",
                }}
              >
                {approval?.job?.creativeDescription?.length > 17
                  ? `${approval?.job?.creativeDescription.substring(0, 17)}...`
                  : approval?.job?.creativeDescription || "Not Available"}
              </span>
            </Tooltip>
          </TableCell>
          {/* NEW COMMENT COLUMN CELL */}
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
              borderLeft: "1px solid #ddd",
              textAlign: "center",
            }}
          >
            <div className="flex justify-center items-center gap-3">
              {!approval?.job?.vendorDocumentFile ? (
                <>
                  {/* UPLOAD */}
                  <Tooltip title="Upload PDF">
                    <IconButton
                      size="small"
                      onClick={() =>
                        document
                          .getElementById(`vendor-file-${approval._id}`)
                          .click()
                      }
                      sx={{ color: "#2563eb" }}
                    >
                      <UploadFileOutlined fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  <input
                    type="file"
                    accept="application/pdf"
                    id={`vendor-file-${approval._id}`}
                    style={{ display: "none" }}
                    onChange={(e) => handleVendorDocumentChange(e, approval)}
                  />
                </>
              ) : (
                <>
                  {/* VIEW */}
                  <Tooltip title="View PDF">
                    <IconButton
                      size="small"
                      onClick={() =>
                        window.open(approval.job.vendorDocumentFile, "_blank")
                      }
                      sx={{
                        color: "#4b5563",
                      }}
                    >
                      <VisibilityOutlined fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  {/* UPDATE */}
                  <Tooltip title="Update PDF">
                    <IconButton
                      size="small"
                      onClick={() =>
                        document
                          .getElementById(`vendor-file-${approval._id}`)
                          .click()
                      }
                      sx={{
                        color: "#f59e0b",
                      }}
                    >
                      <EditOutlined fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  <input
                    type="file"
                    accept="application/pdf"
                    id={`vendor-file-${approval._id}`}
                    style={{ display: "none" }}
                    onChange={(e) => handleVendorDocumentChange(e, approval)}
                  />
                </>
              )}
            </div>
          </TableCell>

          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
              maxWidth: "200px",
            }}
          >
            {(() => {
              const latest =
                approval?.referenceCreativeTrack !== null &&
                approval?.referenceCreativeTrack?.at(-1);
              if (!latest)
                return (
                  <span
                    className={styles.tableRow}
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "150px",
                      fontSize: "13px",
                    }}
                  >
                    No updates
                  </span>
                );

              const isAdmin = latest.updatedByAdmin;

              const name = latest.adminName || latest.clientName || "Unknown";

              const label = isAdmin ? "CSM" : "Client";

              const dateTime = new Date(latest.updatedAt);

              const date = dateTime.toLocaleDateString("en-GB"); // dd/mm/yyyy
              const time = dateTime.toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false, // 24-hour format
              });

              return (
                <Tooltip
                  title={`${name} (${label})${latest?.behalf ? " upload on behalf of client" : ""}`}
                  arrow
                  placement="top"
                >
                  <div
                    className={`${styles.tableRow} flex flex-col`}
                    style={{
                      maxWidth: "180px",
                      fontSize: "13px",
                      lineHeight: "1.2",
                    }}
                  >
                    {/* 🔹 Line 1 → Name */}
                    <span
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontWeight: 500,
                      }}
                    >
                      {name} {latest?.behalf && "Upload On Behalf Of Client"}
                      {!latest?.behalf && label}
                    </span>

                    {/* 🔹 Line 2 → Date & Time */}
                    <span
                      style={{
                        fontSize: "11px",
                        color: "#888",
                      }}
                    >
                      {date}, {time}
                    </span>
                  </div>
                </Tooltip>
              );
            })()}
          </TableCell>
          <TableCell
            sx={{
              padding: "4px 8px",
              borderRight: "1px solid #ddd",
              maxWidth: "200px",
            }}
          >
            {(() => {
              const latest =
                approval?.creativeTrack !== null &&
                approval?.creativeTrack?.at(-1);
              if (!latest)
                return (
                  <span
                    className={styles.tableRow}
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "150px",
                      fontSize: "13px",
                    }}
                  >
                    No updates
                  </span>
                );

              const isAdmin = latest.updatedByAdmin;

              const name = latest.adminName;

              const label = isAdmin ? "Admin" : "Client";
              const dateTime = new Date(latest.updatedAt);

              const date = dateTime.toLocaleDateString("en-GB"); // dd/mm/yyyy
              const time = dateTime.toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false, // 24-hour format
              });
              return (
                <Tooltip
                  title={`${name} (${label}) - ${date} ${time}`}
                  arrow
                  placement="top"
                >
                  <div
                    className={`${styles.tableRow} flex flex-col`}
                    style={{
                      maxWidth: "180px",
                      fontSize: "13px",
                      lineHeight: "1.2",
                    }}
                  >
                    <span
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontWeight: 500,
                      }}
                    >
                      {name}
                    </span>
                    <span
                      style={{
                        fontSize: "11px",
                        color: "#888",
                      }}
                    >
                      {date}, {time}
                    </span>
                  </div>
                </Tooltip>
              );
            })()}
          </TableCell>
        </TableRow>
      );
    });
  }, [
    jobApprovals,
    selectedApprovals,
    canSelectApproval,
    getCommentForStatus,
    handleSelectApproval,
    handleStatus,
    handleReportOpen,
    handleProductChange,
    handleCreativeOpen,
    handleViewRemark,
    handleAddRemark,
    handleVendorDocumentChange,
    handleViewReferenceImage,
    productOptions,
    validationErrors,
  ]);

  return (
    <>
      <div className="p-2">
        <div className="pb-3 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
          {/* LEFT SECTION */}
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between lg:justify-start">
            {/* Back + Title */}
            <div className="flex items-center gap-2">
              <div
                onClick={() =>
                  navigate(`/adminportal/campaign/dashboard/${id}`)
                }
                className="cursor-pointer hover:scale-105 transition"
              >
                <Back size={26} />
              </div>
            </div>

            {/* Chips */}
            <div className="flex items-center border border-1 rounded-md px-1 py-1 gap-3 flex-wrap">
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 700,
                  color: "#374151",
                }}
              >
                Recce :
              </Typography>
              <Chip
                label={`Approved : ${approvedCount || 0}`}
                color="primary"
                size="small"
              />
              <Chip
                label={`Rejected : ${rejectedCount || 0}`}
                color="error"
                size="small"
              />
              <Chip label={`Pending : ${pendingCount || 0}`} size="small" />
              {/* <Chip
                label={`Hold : ${holdOnCount || 0}`}
                size="small"
                sx={{
                  backgroundColor: "#FFF3CD",
                  color: "#856404",
                  fontWeight: 500,
                }}
              /> */}
              <Chip
                label={`Total : ${totalCount || 0}`}
                color="success"
                size="small"
              />
            </div>
          </div>
          <div className="flex items-center border border-1 rounded-md px-1 py-1 gap-3 flex-wrap">
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                color: "#374151",
                mr: 1,
              }}
            >
              Creative :
            </Typography>

            <Chip
              label={`Approved: ${clientCreativeStatus?.approved || 0}`}
              size="small"
              sx={{
                bgcolor: "#DCFCE7",
                color: "#166534",
                fontWeight: 600,
                border: "1px solid #86EFAC",
              }}
            />

            <Chip
              label={`Rejected: ${clientCreativeStatus?.rejected || 0}`}
              size="small"
              sx={{
                bgcolor: "#FEE2E2",
                color: "#991B1B",
                fontWeight: 600,
                border: "1px solid #FCA5A5",
              }}
            />

            <Chip
              label={`Pending: ${clientCreativeStatus?.pending || 0}`}
              size="small"
              sx={{
                bgcolor: "#FEF3C7",
                color: "#92400E",
                fontWeight: 600,
                border: "1px solid #FCD34D",
              }}
            />
          </div>

          {/* RIGHT SECTION */}
          <div className="flex flex-wrap justify-start sm:justify-end items-center gap-2">
            <Tooltip title="Refresh">
              <IconButton
                onClick={resetFilters}
                sx={{
                  animation: rotate ? "spin 0.5s linear" : "none",
                  "@keyframes spin": {
                    "0%": { transform: "rotate(0deg)" },
                    "100%": { transform: "rotate(360deg)" },
                  },
                }}
              >
                <RefreshIcon />
              </IconButton>
            </Tooltip>

            {/* Buttons */}
            <TextField
              size="small"
              placeholder="Search store / city / product..."
              value={search}
              onChange={(e) => {
                const value = e.target.value;
                setSearch(value);
                setPage(1);

                const searchText = value.toLowerCase();

                if (!searchText) {
                  setJobApprovals(allApprovals);
                  return;
                }

                // const filtered = allApprovals.filter((item) => {
                //   return (
                //     item?.job?.storeName?.toLowerCase().includes(searchText) ||
                //     item?.job?.city?.toLowerCase().includes(searchText) ||
                //     item?.job?.state?.toLowerCase().includes(searchText) ||
                //     item?.product?.productType
                //       ?.toLowerCase()
                //       .includes(searchText)
                //   );
                // });

                // setJobApprovals(filtered); // 👈 direct update
              }}
              sx={{ width: "280px", background: "#fff" }}
            />
            <IconButton
              size="small"
              onClick={(event) => setAnchorE2(event.currentTarget)}
              sx={{
                border: "1px solid #d1d5db",
                borderRadius: "6px",
                backgroundColor: "#fff",
              }}
            >
              <MoreVertIcon fontSize="small" />
            </IconButton>
            <Menu
              anchorEl={anchorE2}
              open={Boolean(anchorE2)}
              onClose={() => setAnchorE2(null)}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              slotProps={{
                paper: {
                  sx: {
                    mt: 1,
                    minWidth: 180,
                    borderRadius: "8px",
                    boxShadow: "0px 4px 15px rgba(0,0,0,0.15)",
                  },
                },
              }}
            >
              <MenuItem
                onClick={() => {
                  setAnchorE2(null);
                  setDocModalOpen(true);
                }}
              >
                <ListItemIcon>
                  <DescriptionOutlinedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Docs" />
              </MenuItem>

              <MenuItem
                onClick={() => {
                  setAnchorE2(null);
                  setClientApprovalOpen(true);
                }}
              >
                <ListItemIcon>
                  <VisibilityOutlinedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Client View" />
              </MenuItem>
              <MenuItem
                disabled={jobApprovals.length === 0}
                onClick={() => {
                  setAnchorE2(null);
                  setIsModalOpen(true);
                }}
              >
                <ListItemIcon>
                  <AssignmentOutlinedIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Recce Template" />
              </MenuItem>
            </Menu>
            {/* <Button
              variant="outlined"
              color="secondary"
              size="small"
              onClick={() => setDocModalOpen(true)}
            >
              Docs
            </Button>

            <Button
              variant="outlined"
              color="success"
              size="small"
              onClick={() => setClientApprovalOpen(true)}
            >
              Client View
            </Button>

            <Button
              variant="contained"
              size="small"
              disabled={jobApprovals.length === 0}
              onClick={() => setIsModalOpen(true)}
              sx={{
                textTransform: "none",
                backgroundColor:
                  jobApprovals.length === 0 ? "#9ca3af" : "#2563eb",
                "&:hover": {
                  backgroundColor:
                    jobApprovals.length === 0 ? "#9ca3af" : "#1d4ed8",
                },
              }}
            >
              Recce Template
            </Button> */}
          </div>
        </div>
        {isModalOpen && (
          <TemplateModal
            isOpen={isModalOpen}
            isPreviewCompletionReport={isPreviewCompletionReport}
            // recceData={filterJobApprovals}
            recceData={jobApprovals}
            role={"admin"}
            onClose={() => setIsModalOpen(false)}
            handleCreativeOpen={handleCreativeOpen}
            refreshCreative={refreshCreative}
            getApprovalList={getApprovalList}
          />
        )}

        <Paper
          sx={{
            width: "100%",
            backgroundColor: "white",
            borderRadius: "10px",
            border: 0,
          }}
          className=""
        >
          <TableContainer
            sx={{
              height: "calc(95vh - 160px)",
              maxHeight: "calc(95vh - 160px)",
              overflowY: "auto",
            }}
            className={`rounded-sm ${styles["custom-scrollbar"]}`}
          >
            <Table stickyHeader className="rounded-lg">
              <TableHead>
                <TableRow
                  hover
                  sx={{
                    cursor: "pointer",
                    height: "40px",
                    minHeight: "40px",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                    position: "sticky",
                    top: 0,
                    zIndex: 11,
                    backgroundColor: "white",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  <TableCell
                    align="center"
                    sx={{
                      position: "sticky",
                      left: 0,
                      padding: "4px 8px",
                      zIndex: 20,
                      width: "50px",
                      borderRight: "1px solid #ddd",
                    }}
                  >
                    <Checkbox
                      checked={isSelectAll}
                      onChange={handleSelectAll}
                      icon={<CheckBoxOutlineBlankIcon />}
                      checkedIcon={<CheckBoxIcon />}
                      disabled={
                        jobApprovals.filter(
                          (approval) => approval.adminStatus === 0,
                        ).length === 0
                      }
                    />
                  </TableCell>

                  <TableCell
                    colSpan={4}
                    align="center"
                    sx={{
                      borderRight: "1px solid #ddd",
                      height: "40px",
                      padding: "4px 8px",
                    }}
                  >
                    <div className={styles.tableHead} style={{ lineHeight: 1 }}>
                      Location Details
                    </div>
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      borderRight: "1px solid #ddd",
                      height: "40px",
                      padding: "4px 16px",
                    }}
                  >
                    <div
                      className={`${styles.tableHead} flex items-center justify-center gap-2`}
                      onClick={sortByZone}
                    >
                      Zone
                      {zoneSortOrder !== "desc" ? (
                        <ArrowUpwardIcon sx={{ fontSize: 16 }} />
                      ) : (
                        <ArrowDownwardIcon sx={{ fontSize: 16 }} />
                      )}
                    </div>
                  </TableCell>
                  {/* <TableCell
                    align="start"
                    sx={{
                      borderRight: "1px solid #ddd",
                      padding: "4px 8px",
                      height: "40px",
                      cursor: "pointer",
                    }}
                    onClick={sortByStoreName}
                  >
                    <div
                      className={`${styles.tableHead} flex justify-between items-center`}
                      style={{
                        lineHeight: 1,
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      Store Name
                      {storeSortOrder === "asc" ? (
                        <ArrowUpwardIcon sx={{ fontSize: 16 }} />
                      ) : (
                        <ArrowDownwardIcon sx={{ fontSize: 16 }} />
                      )}
                    </div>
                  </TableCell> */}

                  <TableCell
                    colSpan={localStorage.getItem("role") == "-1" ? 3 : 2}
                    align="center"
                    sx={{
                      borderLeft: "1px solid #ddd",
                      borderRight: "1px solid #ddd",
                      height: "40px",
                      padding: "4px 8px",
                    }}
                  >
                    <div className={styles.tableHead} style={{ lineHeight: 1 }}>
                      Available Space
                    </div>
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      height: "40px",
                      padding: "4px 8px",
                      borderRight: "1px solid #ddd",
                      width: "120px",
                    }}
                  >
                    <div className={styles.tableHead} style={{ lineHeight: 1 }}>
                      Product Type
                    </div>
                  </TableCell>
                  {localStorage.getItem("role") == -1 && (
                    <TableCell
                      align="center"
                      sx={{
                        height: "40px",
                        padding: "4px 8px",
                        borderRight: "1px solid #ddd",
                      }}
                    >
                      <div
                        className={styles.tableHead}
                        style={{ lineHeight: 1 }}
                      >
                        Amount
                      </div>
                    </TableCell>
                  )}

                  <TableCell
                    align="center"
                    sx={{
                      height: "40px",
                      padding: "4px 8px",
                      borderRight: "1px solid #ddd",
                    }}
                  >
                    <div className={styles.tableHead} style={{ lineHeight: 1 }}>
                      Recce Report
                    </div>
                  </TableCell>
                  {localStorage.getItem("role") != 7 && (
                    <TableCell
                      align="center"
                      sx={{
                        height: "40px",
                        padding: "4px 8px",
                        borderRight: "1px solid #ddd",
                      }}
                    >
                      <div
                        className={styles.tableHead}
                        style={{ lineHeight: 1 }}
                      >
                        Actions
                      </div>
                    </TableCell>
                  )}

                  <TableCell
                    align="center"
                    sx={{
                      height: "40px",
                      padding: "4px 8px",
                      borderRight: "1px solid #ddd",
                    }}
                  >
                    <div className={styles.tableHead} style={{ lineHeight: 1 }}>
                      Ops Status
                    </div>
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      height: "40px",
                      padding: "4px 8px",
                      borderRight: "1px solid #ddd",
                      borderLeft: "1px solid #ddd",
                    }}
                  >
                    <div className={styles.tableHead} style={{ lineHeight: 1 }}>
                      Client Status
                    </div>
                  </TableCell>
                  <TableCell
                    colSpan={2}
                    align="center"
                    sx={{
                      borderLeft: "1px solid #ddd",

                      height: "40px",
                      padding: "4px 8px",
                    }}
                  >
                    <div className={styles.tableHead} style={{ lineHeight: 1 }}>
                      Recce Approval
                    </div>
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      height: "40px",
                      padding: "4px 8px",
                      borderRight: "1px solid #ddd",
                      borderLeft: "1px solid #ddd",
                    }}
                  >
                    <div className={styles.tableHead} style={{ lineHeight: 1 }}>
                      Recce Remarks
                    </div>
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      borderRight: "1px solid #ddd",
                      height: "40px",
                    }}
                  >
                    <div className={styles.tableHead}>
                      <div className="flex items-center justify-center">
                        OPS Approval Comments
                      </div>
                    </div>
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      height: "40px",
                      padding: "4px 8px",
                      borderRight: "1px solid #ddd",
                      borderLeft: "1px solid #ddd",
                    }}
                  >
                    <div className={styles.tableHead} style={{ lineHeight: 1 }}>
                      Upload Creative
                    </div>
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      height: "40px",
                      padding: "4px 8px",
                      borderRight: "1px solid #ddd",
                      borderLeft: "1px solid #ddd",
                    }}
                  >
                    <div className={styles.tableHead} style={{ lineHeight: 1 }}>
                      Ref. Creative
                    </div>
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      height: "40px",
                      padding: "4px 8px",
                      borderRight: "1px solid #ddd",
                    }}
                  >
                    <div className={styles.tableHead} style={{ lineHeight: 1 }}>
                      Ref. Creative Description
                    </div>
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      height: "40px",
                      padding: "4px 8px",
                      borderRight: "1px solid #ddd",
                    }}
                  >
                    <div className={styles.tableHead} style={{ lineHeight: 1 }}>
                      Upload Sign Manual
                    </div>
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      borderRight: "1px solid #ddd",
                      borderLeft: "1px solid #ddd",

                      height: "40px",
                    }}
                  >
                    <div className={styles.tableHead}>
                      <div className="flex items-center justify-center">
                        Last Ref. Creative Upload
                      </div>
                    </div>
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      borderRight: "1px solid #ddd",
                      height: "40px",
                    }}
                  >
                    <div className={styles.tableHead}>
                      <div className="flex items-center justify-center">
                        Last Creative Upload
                      </div>
                    </div>
                  </TableCell>
                </TableRow>

                {/* Second Header Row - Sub Headers */}
                <TableRow
                  hover
                  sx={{
                    cursor: "pointer",
                    height: "40px",
                    minHeight: "40px",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                    position: "sticky",
                    top: "40px",
                    zIndex: 11,
                    backgroundColor: "#eaebed",
                  }}
                >
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      height: "40px",
                      backgroundColor: "#eaebed",

                      padding: "4px 8px",
                      zIndex: 20,
                      width: "50px",
                      borderRight: "1px solid #ddd",
                    }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#eaebed",
                      height: "40px",
                      padding: "4px 8px",
                      textAlign: "center",
                      verticalAlign: "middle",
                    }}
                  >
                    <div
                      className={styles.tableSubHead}
                      style={{ lineHeight: 1 }}
                    >
                      State
                    </div>
                  </TableCell>

                  <TableCell
                    sx={{
                      backgroundColor: "#eaebed",
                      height: "40px",
                      padding: "4px 8px",
                      textAlign: "center",
                      verticalAlign: "middle",
                    }}
                  >
                    <div
                      className={styles.tableSubHead}
                      style={{ lineHeight: 1 }}
                    >
                      City
                    </div>
                  </TableCell>

                  <TableCell
                    sx={{
                      backgroundColor: "#eaebed",
                      height: "40px",
                      padding: "4px 8px",
                    }}
                  >
                    <div
                      className={styles.tableSubHead}
                      style={{
                        lineHeight: 1,
                        borderLeft: "1px solid #ddd",
                      }}
                    >
                      Address
                    </div>
                  </TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#eaebed",
                      height: "40px",
                      padding: "4px 8px",
                      borderRight: "1px solid #ddd",
                    }}
                  >
                    <div
                      className={styles.tableSubHead}
                      onClick={sortByStoreName}
                    >
                      Store Name
                      {storeSortOrder !== "desc" ? (
                        <ArrowUpwardIcon
                          sx={{
                            fontSize: 16,
                            marginLeft: "4px",
                            marginBottom: "4px",
                          }}
                        />
                      ) : (
                        <ArrowDownwardIcon
                          sx={{
                            fontSize: 16,
                            marginLeft: "4px",
                            marginBottom: "4px",
                          }}
                        />
                      )}
                    </div>
                  </TableCell>

                  <TableCell
                    sx={{
                      backgroundColor: "#eaebed",
                      height: "40px",
                      padding: "4px 8px",
                      borderRight: "1px solid #ddd",
                    }}
                  ></TableCell>

                  <TableCell
                    sx={{
                      backgroundColor: "#eaebed",
                      height: "40px",
                      padding: "4px 8px",
                      borderRight: "1px solid #eaebed",
                      borderLeft: "1px solid #ddd",
                    }}
                  >
                    <div
                      className={styles.tableSubHead}
                      style={{ lineHeight: 1 }}
                    >
                      Width
                    </div>
                  </TableCell>

                  <TableCell
                    sx={{
                      backgroundColor: "#eaebed",
                      height: "40px",
                      padding: "4px 8px",
                      borderRight:
                        localStorage.getItem("role") !== "-1"
                          ? "1px solid #ddd"
                          : "none",
                    }}
                  >
                    <div
                      className={styles.tableSubHead}
                      style={{ lineHeight: 1 }}
                    >
                      Height
                    </div>
                  </TableCell>
                  {localStorage.getItem("role") == -1 && (
                    <TableCell
                      sx={{
                        backgroundColor: "#eaebed",

                        borderRight: "1px solid #ddd",
                        height: "40px",
                        padding: "4px 8px",
                      }}
                    >
                      <div className={styles.tableSubHead}>Area (sq ft)</div>
                    </TableCell>
                  )}

                  <TableCell
                    sx={{
                      backgroundColor: "#eaebed",
                      borderRight: "1px solid #ddd",
                      height: "40px",
                      padding: "4px 8px",
                      textAlign: "center",
                      verticalAlign: "middle",
                    }}
                  ></TableCell>
                  {localStorage.getItem("role") == -1 && (
                    <TableCell
                      sx={{
                        backgroundColor: "#eaebed",
                        borderRight: "1px solid #ddd",

                        height: "40px",
                        padding: "4px 8px",
                      }}
                    ></TableCell>
                  )}
                  <TableCell
                    sx={{
                      backgroundColor: "#eaebed",
                      borderRight: "1px solid #ddd",

                      height: "40px",
                      padding: "4px 8px",
                    }}
                  ></TableCell>
                  {localStorage.getItem("role") != 7 && (
                    <TableCell
                      sx={{
                        backgroundColor: "#eaebed",
                        borderRight: "1px solid #ddd",

                        height: "40px",
                        padding: "4px 8px",
                      }}
                    ></TableCell>
                  )}
                  <TableCell
                    sx={{
                      backgroundColor: "#eaebed",
                      borderRight: "1px solid #ddd",

                      height: "40px",
                      padding: "4px 8px",
                    }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#eaebed",
                      borderRight: "1px solid #ddd",

                      height: "40px",
                      padding: "4px 8px",
                    }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#eaebed",
                      height: "40px",
                      padding: "4px 8px",
                      borderLeft: "1px solid #ddd",
                    }}
                  >
                    <div
                      className={styles.tableSubHead}
                      style={{ lineHeight: 1 }}
                    >
                      Kam
                    </div>
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      backgroundColor: "#eaebed",
                      height: "40px",
                      padding: "4px 8px",
                      width: "300px",
                    }}
                  >
                    <div
                      className={styles.tableSubHead}
                      style={{ lineHeight: 1 }}
                    >
                      Client
                    </div>
                  </TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#eaebed",
                      borderRight: "1px solid #ddd",
                      borderLeft: "1px solid #ddd",
                      verticalAlign: "middle",
                      padding: "2px 6px",
                    }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#eaebed",
                      borderRight: "1px solid #ddd",
                      borderLeft: "1px solid #ddd",
                      verticalAlign: "middle",
                      padding: "2px 6px",
                    }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#eaebed",
                      borderRight: "1px solid #ddd",
                      verticalAlign: "middle",
                      padding: "2px 6px",
                    }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#eaebed",
                      borderRight: "1px solid #ddd",
                      verticalAlign: "middle",
                      padding: "2px 6px",
                    }}
                  ></TableCell>

                  <TableCell
                    sx={{
                      backgroundColor: "#eaebed",
                      borderRight: "1px solid #ddd",
                      verticalAlign: "middle",
                      padding: "2px 6px",
                    }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#eaebed",
                      borderRight: "1px solid #ddd",
                      verticalAlign: "middle",
                      padding: "2px 6px",
                    }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#eaebed",
                      borderRight: "1px solid #ddd",
                      verticalAlign: "middle",
                      padding: "2px 6px",
                    }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      backgroundColor: "#eaebed",
                      borderRight: "1px solid #ddd",
                      verticalAlign: "middle",
                      padding: "2px 6px",
                    }}
                  ></TableCell>
                </TableRow>

                {/* Third Row - Filters Row */}
                <TableRow
                  sx={{
                    height: "40px",
                    minHeight: "40px",
                    position: "sticky",
                    top: "80px",
                    zIndex: 10,
                    backgroundColor: "#f8f9fa",
                    borderBottom: "2px solid #e0e0e0",
                  }}
                >
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      height: "40px",
                      zIndex: 20,
                      background: "white",
                      width: "50px",
                      padding: "2px 6px",
                      borderRight: "1px solid #ddd",
                      backgroundColor: "#f8f9fa",
                      verticalAlign: "middle",
                    }}
                  ></TableCell>
                  <TableCell sx={baseFilterCss}>
                    <GlobalDropdownField
                      search={true}
                      variant="compact" // ✅ use the compact variant
                      name="stateFilter"
                      value={selectedState || []}
                      multiple={true}
                      onChange={(e) => handleSearchChangeHead(e, "state")}
                      placeholder="Filter State"
                      options={[
                        { value: "ALL", label: "All States" },
                        ...stateOptions,
                      ]}
                      renderValueFn={(selected) => {
                        if (!selected || selected.length === 0) {
                          return "Filter State";
                        }

                        const cleanSelected = selected.includes("ALL")
                          ? stateOptions.map((s) => s.value)
                          : selected;

                        const labels = cleanSelected.map(
                          (val) =>
                            stateOptions.find((s) => s.value === val)?.label ||
                            val,
                        );

                        const visible = labels.slice(0, 1);
                        const remaining = labels.length - 1;

                        return (
                          <span style={{ fontSize: "0.75rem" }}>
                            {visible.join(", ")}
                            {remaining > 0 && ` +${remaining} more`}
                          </span>
                        );
                      }}
                      useNewStyles={true}
                    />
                  </TableCell>
                  {/* City Filter */}
                  <TableCell sx={baseFilterCss}>
                    <GlobalDropdownField
                      variant="compact"
                      search={true}
                      name="cityFilter"
                      multiple={true}
                      value={selectedCity || []}
                      onChange={(e) => handleSearchChangeHead(e, "city")}
                      placeholder="Filter City"
                      options={[
                        { value: "ALL", label: "All Cities" },
                        ...getFilteredCities(),
                      ]}
                      renderValueFn={(selected) => {
                        if (!selected || selected.length === 0) {
                          return "Filter City";
                        }

                        const isAllSelected =
                          selected.includes("ALL") ||
                          selected.length === cityOptions.length;
                        if (isAllSelected) {
                          return (
                            <span style={{ fontSize: "0.75rem" }}>
                              All Cities
                            </span>
                          );
                        }

                        // 👉 Normal case
                        const labels = selected.map(
                          (val) =>
                            cityOptions.find((s) => s.value === val)?.label ||
                            val,
                        );

                        const displayLabels = labels.slice(0, 2);

                        return (
                          <span style={{ fontSize: "0.75rem" }}>
                            {displayLabels.join(", ")}
                            {labels.length > 2 && " ..."}
                          </span>
                        );
                      }}
                      useNewStyles={true}
                    />
                  </TableCell>
                  <TableCell sx={baseFilterCss}></TableCell>
                  <TableCell sx={withBorderCss}>
                    <GlobalDropdownField
                      variant="compact" // ✅ use the compact variant
                      name="storeFilter"
                      search={true}
                      multiple={true}
                      value={selectedStore || []}
                      onChange={(e) => handleSearchChangeHead(e, "store")}
                      placeholder="Filter Store"
                      options={[
                        { value: "ALL", label: "All Stores" },
                        ...storeOptions,
                      ]}
                      renderValueFn={(selected) => {
                        if (!selected || selected.length === 0) {
                          return "Filter Store";
                        }

                        // 👉 Check ALL condition
                        const isAllSelected =
                          selected.includes("ALL") ||
                          selected.length === storeOptions.length;

                        if (isAllSelected) {
                          return (
                            <span style={{ fontSize: "0.75rem" }}>
                              All Stores
                            </span>
                          );
                        }

                        // 👉 Normal case
                        const labels = selected.map(
                          (val) =>
                            storeOptions.find((s) => s.value === val)?.label ||
                            val,
                        );

                        const displayLabels = labels.slice(0, 2);

                        return (
                          <span style={{ fontSize: "0.75rem" }}>
                            {displayLabels.join(", ")}
                            {labels.length > 2 && " ..."}
                          </span>
                        );
                      }}
                      useNewStyles={true}
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      ...baseFilterCss,
                      borderRight: "1px solid #ddd",
                    }}
                  >
                    <GlobalDropdownField
                      variant="compact"
                      name="zoneFilter"
                      search={true}
                      multiple={true}
                      value={selectedZone || []}
                      onChange={(e) => handleSearchChangeHead(e, "zone")}
                      placeholder="Filter Zone"
                      options={[
                        { value: "ALL", label: "All Zones" },
                        ...zoneOptions,
                      ]}
                      renderValueFn={(selected) => {
                        if (!selected || selected.length === 0) {
                          return "Filter Zone";
                        }

                        if (
                          selected.includes("ALL") ||
                          selected.length === zoneOptions.length
                        ) {
                          return (
                            <span style={{ fontSize: "0.75rem" }}>
                              All Zones
                            </span>
                          );
                        }

                        const labels = selected.map(
                          (value) =>
                            zoneOptions.find((zone) => zone.value === value)
                              ?.label || value,
                        );

                        return (
                          <span style={{ fontSize: "0.75rem" }}>
                            {labels.slice(0, 2).join(", ")}
                            {labels.length > 2 && " ..."}
                          </span>
                        );
                      }}
                      useNewStyles={true}
                    />
                  </TableCell>

                  {/* Address Filter */}
                  {/* No filter for address */}

                  {/* Width Filter (Scope of Work) */}
                  {localStorage.getItem("role") == -1 && (
                    <TableCell sx={baseFilterCss} />
                  )}
                  {/* No filter for width */}

                  {/* Height Filter (Scope of Work) */}
                  <TableCell sx={baseFilterCss} />
                  {/* No filter for height */}

                  {/* Area Filter */}
                  <TableCell sx={withBorderCss} />

                  {/* Product Type Filter */}
                  <TableCell sx={withBorderCss}>
                    <GlobalDropdownField
                      variant="compact"
                      name="productTypeFilter"
                      search={true}
                      multiple={true}
                      value={selectedProductType || []}
                      onChange={(e) => handleSearchChangeHead(e, "productType")}
                      placeholder="Filter Product"
                      options={(() => {
                        let filteredProductTypes = [];

                        const cleanStates = selectedState?.includes("ALL")
                          ? Object.keys(productTypesByState || {})
                          : selectedState;

                        const cleanCities = selectedCity?.includes("ALL")
                          ? Object.keys(productTypesByCity || {})
                          : selectedCity;

                        if (cleanStates?.length && cleanCities?.length) {
                          filteredProductTypes = cleanStates.flatMap((st) =>
                            cleanCities.flatMap((ct) => {
                              const key = `${st}||${ct}`;
                              return productTypesByStateCityMap[key] || [];
                            }),
                          );
                        } else if (cleanStates?.length) {
                          filteredProductTypes = cleanStates.flatMap(
                            (st) => productTypesByState[st] || [],
                          );
                        } else if (cleanCities?.length) {
                          filteredProductTypes = cleanCities.flatMap(
                            (ct) => productTypesByCity[ct] || [],
                          );
                        }

                        const uniqueProducts = [
                          ...new Set(filteredProductTypes),
                        ];

                        const productOptions = uniqueProducts.map((pt) => ({
                          label: pt,
                          value: pt,
                        }));

                        return [
                          { value: "ALL", label: "All Products" },
                          ...(productOptions.length > 0
                            ? productOptions
                            : allProductTypeOptions),
                        ];
                      })()}
                      renderValueFn={(selected) => {
                        if (!selected || selected.length === 0) {
                          return "Filter Product";
                        }

                        const cleanSelected = selected.includes("ALL")
                          ? allProductTypeOptions.map((p) => p.value)
                          : selected;

                        const labels = cleanSelected.map(
                          (val) =>
                            allProductTypeOptions.find((p) => p.value === val)
                              ?.label || val,
                        );

                        const visible = labels.slice(0, 1);
                        const remaining = labels.length - 1;

                        return (
                          <span style={{ fontSize: "0.75rem" }}>
                            {visible.join(", ")}
                            {remaining > 0 && ` +${remaining} more`}
                          </span>
                        );
                      }}
                      useNewStyles={true}
                    />
                  </TableCell>

                  {/* Amount Filter */}
                  {localStorage.getItem("role") == -1 && (
                    <TableCell sx={withBorderCss} />
                  )}

                  {/* Report Filter */}
                  {localStorage.getItem("role") != 7 && (
                    <TableCell sx={withBorderCss} />
                  )}
                  {/* Admin Status Filter */}
                  <TableCell
                    sx={{
                      padding: "2px 6px",
                      borderRight: "1px solid #ddd",
                      backgroundColor: "#f8f9fa",
                      verticalAlign: "middle",
                      minWidth: "160px",
                      width: "160px",
                    }}
                  >
                    {selectedApprovals.length > 0 && (
                      <div className="flex justify-center items-center gap-2">
                        <GlobalButton
                          variant="primary"
                          size="small"
                          onClick={handleBulkApprove}
                        >
                          Approve {selectedApprovals.length}
                        </GlobalButton>
                        <GlobalButton
                          variant="warning"
                          size="small"
                          onClick={handleBulkReject}
                          style={{ width: "auto", whiteSpace: "nowrap" }}
                        >
                          Reject {selectedApprovals.length}
                        </GlobalButton>
                      </div>
                    )}
                  </TableCell>

                  {/* Client Status Filter */}
                  <TableCell
                    sx={{
                      padding: "2px 6px",
                      borderRight: "1px solid #ddd",
                      backgroundColor: "#f8f9fa",
                      verticalAlign: "middle",
                    }}
                  >
                    <GlobalDropdownField
                      variant="compact"
                      search={true}
                      name="productTypeFilter"
                      value={selectedAdminStatus}
                      onChange={(e) => handleSearchChangeHead(e, "adminStatus")}
                      placeholder="Select Status"
                      multiple={true}
                      options={[
                        { label: "All", value: "ALL" },
                        { label: "Approved", value: 1 },
                        { label: "Rejected", value: -1 },
                        { label: "Pending", value: 0 },
                      ]}
                      renderValueFn={(selected) => {
                        if (!selected || selected.length === 0) {
                          return "Select Status";
                        }

                        const allOptions = [
                          { label: "Approved", value: 1 },
                          { label: "Rejected", value: -1 },
                          { label: "Pending", value: 0 },
                        ];

                        const cleanSelected = selected.includes("ALL")
                          ? allOptions.map((o) => o.value)
                          : selected;

                        const labels = cleanSelected.map(
                          (val) =>
                            allOptions.find((o) => o.value === val)?.label,
                        );

                        const visible = labels.slice(0, 1);
                        const remaining = labels.length - 1;

                        return (
                          <span style={{ fontSize: "0.75rem" }}>
                            {visible.join(", ")}
                            {remaining > 0 && ` +${remaining} more`}
                          </span>
                        );
                      }}
                      useNewStyles={true}
                    />
                  </TableCell>

                  {/* KAM Filter */}
                  <TableCell
                    sx={{
                      padding: "4px 8px",
                      borderRight: "1px solid #ddd",
                      height: "40px",
                    }}
                  >
                    <GlobalDropdownField
                      variant="compact"
                      search={true}
                      name="productTypeFilter"
                      value={selectedClientStatus}
                      onChange={(e) =>
                        handleSearchChangeHead(e, "clientStatus")
                      }
                      multiple={true}
                      placeholder="Select Status"
                      options={[
                        { label: "All", value: "ALL" },
                        { label: "Approved", value: 1 },
                        { label: "Ignore", value: -1 },
                        { label: "Hold On", value: 2 },
                        { label: "Pending", value: 0 },
                      ]}
                      renderValueFn={(selected) => {
                        if (!selected || selected.length === 0) {
                          return "Select Status";
                        }

                        const allOptions = [
                          { label: "Approved", value: 1 },
                          { label: "Ignore", value: -1 },
                          { label: "Hold On", value: 2 },
                          { label: "Pending", value: 0 },
                        ];

                        const cleanSelected = selected.includes("ALL")
                          ? allOptions.map((o) => o.value)
                          : selected;

                        const labels = cleanSelected.map(
                          (val) =>
                            allOptions.find((o) => o.value === val)?.label,
                        );

                        const visible = labels.slice(0, 1);
                        const remaining = labels.length - 1;

                        return (
                          <span style={{ fontSize: "0.75rem" }}>
                            {visible.join(", ")}
                            {remaining > 0 && ` +${remaining} more`}
                          </span>
                        );
                      }}
                      useNewStyles={true}
                    />
                  </TableCell>

                  {/* Client Filter */}
                  <TableCell
                    sx={{
                      height: "40px",
                      padding: "4px 8px",
                      borderLeft: "1px solid #ddd",
                    }}
                  >
                    <div
                      className={styles.tableSubHead}
                      style={{ lineHeight: 1 }}
                    ></div>
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #ddd",
                      verticalAlign: "middle",
                      padding: "2px 6px",
                    }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      padding: "2px 6px",
                      borderRight: "1px solid #ddd",
                      verticalAlign: "middle",
                    }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      padding: "2px 6px",
                      borderRight: "1px solid #ddd",
                      verticalAlign: "middle",
                    }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      padding: "4px 8px",
                      borderRight: "1px solid #ddd",
                      height: "40px",
                    }}
                  >
                    <GlobalDropdownField
                      variant="compact"
                      search={true}
                      name="productTypeFilter"
                      value={selectedCreativeStatus}
                      onChange={(e) =>
                        handleSearchChangeHead(e, "creativeStatus")
                      }
                      multiple={true}
                      placeholder="Select Status"
                      options={[
                        { label: "All", value: "ALL" },
                        { label: "Approved", value: 1 },
                        { label: "Reject", value: -1 },
                        { label: "Pending", value: 0 },
                      ]}
                      renderValueFn={(selected) => {
                        if (!selected || selected.length === 0) {
                          return "Select Status";
                        }

                        const allOptions = [
                          { label: "Approved", value: 1 },
                          { label: "Reject", value: -1 },
                          { label: "Pending", value: 0 },
                        ];

                        const cleanSelected = selected.includes("ALL")
                          ? allOptions.map((o) => o.value)
                          : selected;

                        const labels = cleanSelected.map(
                          (val) =>
                            allOptions.find((o) => o.value === val)?.label,
                        );

                        const visible = labels.slice(0, 1);
                        const remaining = labels.length - 1;

                        return (
                          <span style={{ fontSize: "0.75rem" }}>
                            {visible.join(", ")}
                            {remaining > 0 && ` +${remaining} more`}
                          </span>
                        );
                      }}
                      useNewStyles={true}
                    />
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "2px 6px",
                      borderRight: "1px solid #ddd",
                      verticalAlign: "middle",
                    }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      padding: "2px 6px",
                      borderRight: "1px solid #ddd",
                      verticalAlign: "middle",
                    }}
                  ></TableCell>

                  <TableCell
                    sx={{
                      padding: "2px 6px",
                      borderRight: "1px solid #ddd",
                      verticalAlign: "middle",
                    }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      padding: "2px 6px",
                      borderRight: "1px solid #ddd",
                      verticalAlign: "middle",
                    }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      padding: "2px 6px",
                      borderRight: "1px solid #ddd",
                      verticalAlign: "middle",
                    }}
                  ></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {campaignListLoading ? (
                  // Show loading spinner in TableBody while keeping headers visible
                  <TableRow>
                    <TableCell
                      colSpan={23}
                      align="center"
                      sx={{
                        padding: "40px 16px",
                        textAlign: "center",
                        border: "none",
                        height: "calc(95vh - 225px)",
                      }}
                    >
                      <div className="flex flex-col items-center justify-center min-h-[300px]">
                        <CircularProgress size={60} />
                        <Typography
                          variant="body1"
                          sx={{ mt: 2, color: "gray" }}
                        >
                          Loading approvals...
                        </Typography>
                      </div>
                    </TableCell>
                  </TableRow>
                ) : jobApprovals?.length > 0 ? (
                  <>
                    {renderedRows}
                    {localStorage.getItem("role") == -1 && (
                      <TableRow
                        sx={{
                          borderTop: "2px solid #ddd",
                          position: "sticky",
                          bottom: 0,
                          zIndex: 10,
                          backgroundColor: "#fff",
                        }}
                      >
                        <TableCell
                          colSpan={8}
                          sx={{
                            fontWeight: "bold",
                            textAlign: "right",
                          }}
                        ></TableCell>

                        <TableCell
                          sx={{
                            fontWeight: "bold",
                            color: "#1976d2",
                            display: "flex",
                            width: "150px",
                          }}
                        >
                          <p>Total sqft: {totalRecceArea?.toFixed(2)}</p>
                        </TableCell>

                        <TableCell
                          colSpan={10}
                          sx={{
                            fontWeight: "bold",
                            color: "#1976d2",
                          }}
                        ></TableCell>
                        <TableCell
                          colSpan={11}
                          sx={{
                            fontWeight: "bold",
                            color: "#1976d2",
                          }}
                        ></TableCell>
                      </TableRow>
                    )}
                  </>
                ) : (
                  <TableRow
                    sx={{
                      position: "sticky",
                      bottom: 0,
                      background: "#fff",
                      zIndex: 10,
                      borderTop: "2px solid #ddd",
                    }}
                  >
                    <TableCell
                      colSpan={23}
                      align="center"
                      sx={{
                        padding: "40px 16px",
                        textAlign: "center",
                        border: "none",
                      }}
                    >
                      <div className="text-center space-y-4 py-10">
                        <div className="flex justify-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-16 w-16 text-gray-500 animate-bounce"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M9 13h6m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h6l6 6v10a2 2 0 01-2 2z"
                            />
                          </svg>
                        </div>
                        <p className="text-xl font-semibold text-gray-700">
                          No records available for approval
                        </p>
                        <p className="text-sm text-gray-500">
                          Please check again later for new updates.
                        </p>
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* remove comment for pagination */}
          <div className="flex items-center justify-between mt-3 mb-2 ml-2">
            <FormControl
              variant="standard"
              size="small"
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 1,
                "& .MuiInputBase-root:before": { borderBottom: "none" },
                "& .MuiInputBase-root:after": { borderBottom: "none" },
                "& .MuiInputBase-root": { marginTop: 1 }, // 👈 override here
              }}
            >
              <InputLabel
                id="page-size-label"
                sx={{
                  position: "static",
                  transform: "none",
                  fontSize: "14px",
                  marginRight: "8px",
                  marginTop: "2px",
                }}
              >
                Rows
              </InputLabel>
              <Select
                labelId="page-size-label"
                value={pageSize}
                label="Rows"
                onChange={(e) => {
                  setPageSize(e.target.value);
                  setPage(1);
                }}
              >
                {pageSizeOptions.map((size) => (
                  <MenuItem key={size} value={size}>
                    {size}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Pagination
              className="p-2 flex justify-center"
              count={totalPages}
              page={page}
              onChange={handlePageChange}
              sx={{
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: "#418cff",
                  color: "#fff",
                },
                "& .MuiPaginationItem-root.Mui-selected:hover": {
                  backgroundColor: "#3366cc",
                },
                "& .MuiPaginationItem-root": {
                  "&:hover": {
                    backgroundColor: "#ddd",
                  },
                },
              }}
            />
          </div>
        </Paper>

        <GlobalSnackbar snackbar={snackbar} handleClose={handleSnackbarClose} />
        <ApprovalModal
          open={approvalDialogOpen}
          onClose={() => setApprovalDialogOpen(false)}
          onSubmit={(approvalReason) => {
            handleApprovalSubmit(approvalReason);
          }}
        />
        <RecceRejectedModal
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          onSubmit={(rejectionReason) => {
            handleRejectSubmit(rejectionReason);
            setDialogOpen(false);
            setRejectionReason("");
          }}
        />

        {hoveredImage && (
          <div
            style={{
              position: "fixed",
              top: anchorEl?.getBoundingClientRect().top + 30,
              left: anchorEl?.getBoundingClientRect().left,
              zIndex: 1500,
              background: "#fff",
              padding: "8px",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            }}
          >
            <img
              src={hoveredImage}
              alt="preview"
              style={{
                width: "100px",
                height: "auto",
                borderRadius: "6px",
              }}
            />
          </div>
        )}
        {hoveredImageAdmin && (
          <div
            style={{
              position: "fixed",
              top: anchorElAdmin?.getBoundingClientRect().top + 30,
              left: anchorElAdmin?.getBoundingClientRect().left,
              zIndex: 1500,
              background: "#fff",
              padding: "8px",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            }}
          >
            <img
              src={hoveredImageAdmin}
              alt="preview"
              style={{
                width: "100px",
                height: "auto",
                borderRadius: "6px",
              }}
            />
          </div>
        )}
        <Modal
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          open={openCreative}
          // onClose={() => setOpenCreative(false)}
        >
          <Box
            sx={{
              width: "75%",
              bgcolor: "white",
              borderRadius: 3,
              p: 4,
              boxShadow: 24,
              position: "relative",
            }}
          >
            <div className="grid grid-cols-2 gap-6">
              {/* LEFT SIDE PREVIEW */}
              <div className=" rounded-xl p-4 shadow-[0_0_15px_rgba(0,0,0,0.15)]">
                <h2 className="font-semibold text-lg">
                  {selectedApproval?.job?.storeName || "Not Available"}
                </h2>
                <p className="text-sm text-gray-500 mb-4">
                  {selectedApproval?.product?.productType ||
                    "No product type specified"}
                </p>

                <div className="bg-white rounded-lg p-1 my-6 flex justify-center items-center h-auto border-2 border-solid border-blue-500">
                  {selectedApproval?.job?.imageOfRecceSpace ? (
                    <img
                      src={selectedApproval?.job?.imageOfRecceSpace}
                      alt="Creative Preview"
                      className="object-contain  h-full rounded"
                    />
                  ) : (
                    <span className="text-gray-400">No Image Uploaded</span>
                  )}
                </div>
              </div>

              {/* RIGHT SIDE UPLOAD */}
              <DragDropUpload
                accept="image/*"
                maxSize={3 * 1024 * 1024}
                existingFile={selectedApproval?.job?.adaptationImage}
                onUploadComplete={(url) => {
                  setCreativeFile(url);
                }}
                role="admin"
                loading={uploadLoading}
                setOpen={setOpenCreative}
                handleSave={handleCreativeSave}
                handleDelete={handleDeleteUpload}
              />
            </div>

            {/* FOOTER BUTTONS */}
          </Box>
        </Modal>

        <DocModal
          jobApprovals={jobApprovals}
          open={docModalOpen}
          handleClose={() => setDocModalOpen(false)}
        />

        {/* Recce Report Dialog */}
        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth="lg"
          fullWidth
          className="custom-dialog"
          PaperProps={{
            className: "custom-dialog-paper",
          }}
        >
          <DialogContent>
            <RecceReport
              setOpen={setOpen}
              open={open}
              currentApproval={currentApproval}
              finalSpaces={finalSpaces}
              getApprovalList={getApprovalList}
              handleStatus={handleStatus}
              actionButton={true}
            />
          </DialogContent>
        </Dialog>
        <Dialog
          open={clientApprovalOpen}
          onClose={handleClientApprovalClose}
          maxWidth="xl"
          fullWidth
          className="custom-dialog"
          PaperProps={{
            className: "custom-dialog-paper",
          }}
        >
          <DialogContent>
            <RecceApprovalTable
              role={"Admin"}
              username={localStorage.getItem("name")}
              setClientApprovalOpen={setClientApprovalOpen}
            />
          </DialogContent>
        </Dialog>

        <RemarkModal
          open={openRemarkModal}
          onClose={() => setOpenRemarkModal(false)}
          selectedApproval={selectedApproval}
          remarkText={remarkText}
          setRemarkText={setRemarkText}
          isEditingRemark={isEditingRemark}
          setIsEditingRemark={setIsEditingRemark}
          handleEditRemark={handleEditRemark}
          uploadLoading={uploadLoading}
          setUploadLoading={setUploadLoading}
          handleUpdateRemark={(remarkValue) =>
            handleRemarkSave(selectedApproval, remarkValue)
          }
          handleDeleteRemark={() => handleRemarkDelete(selectedApproval)}
        />
        <Dialog
          open={openReferenceImageModal}
          onClose={() => {}}
          disableEscapeKeyDown
          maxWidth={false}
          PaperProps={{
            className: "w-11/12 sm:w-10/12 md:w-8/12 lg:w-6/12 xl:w-5/12",
          }}
        >
          <div className="flex items-center justify-between font-semibold py-3 px-4">
            <h2>Reference Creative</h2>
            <IconButton
              size="small"
              onClick={() => setOpenReferenceImageModal(false)}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </div>

          <div className="flex justify-center items-center p-4 sm:p-6 bg-gray-100 min-h-[300px] sm:min-h-[400px]">
            {referenceImage ? (
              <img
                src={referenceImage}
                alt="Reference Creative"
                className="max-w-full max-h-[300px] sm:max-h-[400px] md:max-h-[500px] rounded-lg shadow-md object-contain"
              />
            ) : (
              <Typography color="textSecondary">No image available</Typography>
            )}
          </div>
        </Dialog>
      </div>
    </>
  );
};

export default AdminApprovalTable;

const baseFilterCss = {
  padding: "2px 6px",
  backgroundColor: "#f8f9fa",
  verticalAlign: "middle",
};

const withBorderCss = {
  ...baseFilterCss,
  borderRight: "1px solid #ddd",
};
